import React, { useEffect, useMemo, useRef, useState } from "react";
import App from "../LayoutMobile";
import { useLocation, useNavigate, Navigate } from "react-router-dom";
import {
  Calendar,
  Select,
  Input,
  Button,
  Table,
  Tag,
  Row,
  Col,
  theme,
  Card,
  Tooltip,
  message,
  Steps,
  Radio,
  Typography,
  Alert,
  ConfigProvider,
  Form,
  Popover,
  Spin,
  Checkbox,
  Dropdown,
  Menu,
  Divider,
  Badge,
  Modal,
  Skeleton,
  Empty,
} from "antd";
import {
  ArrowLeftOutlined,
  LeftOutlined,
  PlusOutlined,
  RightOutlined,
  ClockCircleOutlined,
  SyncOutlined,
  CheckCircleOutlined,
  WarningOutlined,
  CloseCircleOutlined,
  MinusCircleOutlined,
  TagsOutlined,
} from "@ant-design/icons";
import axios from "axios";
import isPostalCode from "validator/lib/isPostalCode";
import moment from "moment";
import "./ClinicCalendarPage.css";
import ClinicCalenderModal from "./ClinicCalenderModal";
import Appointmenttype from "./Appointmenttype";
// import PaymentForm from './PaymentForm';
import BookingForm from "./BookingForm";
import ClinicBooking from "./ClinicBooking";
import PreferredTime from "./PreferredTime";
import BookingDetailsNext from "./BookingDetailsNext";
import Patientdetails from "./Patientdetails";
import dayjs from "dayjs";
import isSameDay from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import CalendarFull from "./CalendarFull";
import { Config } from "../Common/Config";
import { spacerData } from "./CommonApiCallCalender";
import BookingConfirmation from "./BookingConfirmation";
import CalendarEventModal from "./CalendarEventModal";
import CalendarOneDay from "./CalendarOneDay";
import RoomSwapModal from "./RoomSwapModal"; // IOO-307
import { Customappointmentmodal } from "./Customappointmentmodal";
import CreateDropdown from "./CreateDropdown";
import useDebounce from "../Common/useDebounce";
import "dayjs/locale/en-gb";
import enGB from "antd/locale/en_GB";
import {
  postcodeValidator,
  postcodeValidatorExistsForCountry,
} from "postcode-validator";
import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";
import { getNames } from "country-list";
//stripe
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { CreditCardOutlined } from "@ant-design/icons";
// import gpayIcon from '../../Assets/images/paymentlogo/gpay.png'
import {
  useStripe,
  useElements,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
import { pushTraceLogEvent } from "./sessionEventPush";
import useBookingSession from '../../hooks/useBookingSession';
import SessionWarningModal from '../Shared/SessionWarningModal';
dayjs.extend(isSameDay);
dayjs.extend(isSameOrBefore);

const { Option } = Select;
const { Step } = Steps;
const { Title, Text } = Typography;
dayjs.locale("en-gb");
const countryNames = getNames()?.sort();
countryNames[0] = "United Kingdom (UK)";

let stepCss = {
  width: 30,
  height: 30,
  borderRadius: "50%",
  border: "1px solid #008385",
  cursor: "pointer",
};
function formatPrice(value) {
  return Number(value).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}
function ClinicCalendarPage(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const { Title } = Typography;
  const stripe = useStripe();
  const elements = useElements();
  const [selected, setSelected] = useState("");
  const today = moment().format("YYYY-MM-DD");
  const incomingDate = location.state?.date;
  const [publicKey, setPublicKey] = useState(null);
  const [syncloader, setsyncloader] = useState(false);
  // ─── Semble cron tracking state ──────────────────────────────────────────
  // cronStatus: "running" | null  — drives the button + banner UI
  // cronPollIntervalRef: holds the active setInterval so it can be cleared
  // localStorage key "sembleCronRunId" persists the tracked cron run ID
  // across page navigation so the loader resumes if the user navigates away.
  const [cronStatus, setCronStatus] = useState(null);
  const cronPollIntervalRef = useRef(null);
  // ─────────────────────────────────────────────────────────────────────────
  const [selectedCountry, setSelectedCountry] = useState("United kingdom"); // default
  const specialPostcodes = [
    "ASCN 1ZZ",
    "STHL 1ZZ",
    "TDCU 1ZZ",
    "BBND 1ZZ",
    "BIQQ 1ZZ",
    "FIQQ 1ZZ",
    "GX11 1AA",
    "PCRN 1ZZ",
    "SIQQ 1ZZ",
    "TKCA 1ZZ",
  ];
  const [locSearchLog, setlocSearchLog] = useState([]);

  const session_id = localStorage.getItem("trace_log_id");
  // console.log("selectedCountry", selectedCountry)
  let paymentOption = [
    {
      type: "Credit/ debit card",
      displayName: "Credit/ debit card",
      img: null,
    },
    // {
    //     type: 'APay',
    //     displayName: 'Pay',
    //     img: 'https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg',
    // },
    // {
    //     type: 'GPay',
    //     displayName: 'Pay',
    //     img: gpayIcon,
    // },
  ];
  const handleChange = (value) => {
    setSelected((prev) => {
      if (prev === value) {
        form.setFieldsValue({ paymentMethod: undefined });
        return "";
      } else {
        form.setFieldsValue({ paymentMethod: value });
        return value;
      }
    });
  };
  const [form] = Form.useForm();
  const [selectedDate, setSelectedDate] = useState(
    location.state?.redirectFrom == "signal_details"
      ? incomingDate
      : incomingDate === today
        ? incomingDate
        : today,
  );
  // const [selectedDate, setSelectedDate] = useState(location.state?.date || moment().format("YYYY-MM-DD"));
  const [allClinicData, setallClinicData] = useState([]);
  const [showAppoinmentData, setshowAppoinmentData] = useState(null);
  // Bumped whenever a new booking starts so Patientdetails remounts fresh —
  // its dob/phone display state is local (not driven by the Form store),
  // so form.resetFields() alone can't clear what's shown on screen.
  const [patientFormKey, setPatientFormKey] = useState(0);
  const [showAppoinmentDataDisplay, setshowAppoinmentDataDisplay] =
    useState(undefined);
  const [loader, setloader] = useState(false);
  const [loaderTimeAndDate, setloaderTimeAndDate] = useState(false);
  const [loaderCalender, setloaderCalender] = useState(false);
  const [modalStatus, setmodalStatus] = useState(false);
  const [calenderData, setcalenderData] = useState({});
  const [messageApi, contextHolder] = message.useMessage();
  const hasFetched = useRef(false);
  // Several effects (initial mount, clinicSelected change, selectedDate/weekRange change)
  // independently call conflictAlerts() and can all fire within the same initial-load burst.
  // Debounce + an in-flight guard collapse that burst into one set of 5 type requests
  // instead of N*5 — see IOO-388.
  const conflictAlertsInFlightRef = useRef(false);
  const conflictAlertsDebounceRef = useRef(null);
  const [isTypeWeek, setisTypeWeek] = useState(false);
  const [appointmentData, setappointmentData] = useState(null);
  const [lantumStartAndEndDate, setlantumStartAndEndDate] = useState(null);
  // Seed from cache so the Appointment-type screen is instant on repeat visits.
  // The real API still runs in background and refreshes both state + cache.
  const getCachedProducts = () => {
    try {
      const raw = localStorage.getItem('ldc_nonGpProducts_cache');
      if (!raw) return [];
      const { data, ts } = JSON.parse(raw);
      // Bust cache after 24 h so stale products don't linger
      if (Date.now() - ts > 86400000) return [];
      return data;
    } catch { return []; }
  };
  const [getAllHealthScreenData, setgetAllHealthScreenData] = useState(getCachedProducts);
  const [allGPproduct, setallGPproduct] = useState([]);
  const [appointmentType, setappointmentType] = useState(false);
  const [clinicSelected, setclinicSelected] = useState(location.state?.clinic);

  const [errorMessage, seterrorMessage] = useState();
  const [isDifferentCardHolder, setisDifferentCardHolder] = useState(false);
  const [searchPatientInput, setsearchPatientInput] = useState(null);
  const debouncedInputValueData = useDebounce(searchPatientInput, 800);
  const [weekRange, setWeekRange] = useState([]);
  const [open, setOpen] = useState(false);
  const [formloading, setformloading] = useState(false);
  const [spacerAndLunch, setspacerAndLunch] = useState({});
  const [holdAppointmentData, setholdAppointmentData] = useState(null);
  const [searchLoading, setsearchLoading] = useState("");
  const [searchData, setsearchData] = useState({});
  const [bankHolidayByDate, setBankHolidayByDate] = useState({});

  // IOO-275: Session state — managed by useBookingSession hook (wired below)
  const [showTimeExpiredModal, setShowTimeExpiredModal] = useState(false);
  const [currentStep, setCurrentStep] = useState("");
  // IOO-275: tracks bookingSessionId so ClinicBooking re-fetches preferred-clinics with slot_session_id
  const [bookingSessionId, setBookingSessionId] = useState(null);
  const [showCouponInput, setShowCouponInput] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [couponApplied, setCouponApplied] = useState(false);
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [applyingCoupon, setApplyingCoupon] = useState(false);
  const [promoCodeId, setPromoCodeId] = useState(null);

  const resetCouponState = () => {
    setCouponDiscount(0);
    setCouponApplied(false);
    setCouponCode("");
    setPromoCodeId(null);
    setShowCouponInput(false);
  };

  const resetPatientForm = () => {
    form.resetFields();
    form.setFieldsValue({
      first_name: "",
      last_name: "",
      gender: undefined,
      date_of_birth: undefined,
      email: "",
      phone: "",
      mobile_number: "",
      country_code: "+44",
      member_number: "",
      address_1: "",
      address_2: "",
      city: "",
      postalCode: "",
      postalCode1: "",
      postelcode: "",
      appointment_reason: undefined,
      comment: "",
      terms: false,
      marketing: false,
      cardHolderName: undefined,
      isCardHolderDifferent: false,
      paymentMethod: undefined,
    });
  };

  // IOO-307: Room Swap Modal state
  const [roomSwapModalVisible, setRoomSwapModalVisible] = useState(false);
  const [swapSourceRoom, setSwapSourceRoom] = useState(null);
  // IOO-198: stores user-edited preferences from the reschedule preference step
  const [reschedulePreferences, setReschedulePreferences] = useState(null);
  const [stripeError, setStripeError] = useState("");

  const [conflictAlertsData, setconflictAlertsData] = useState([
    {
      id: "clinician_availability_conflict_alert",
      description: "",
      availability: false,
      label_name: "Clinician availability vs booking conflicts",
      data: [],
    },
    {
      id: "spacers_overwritten_alert",
      description: "",
      availability: false,
      label_name: "Spacers overwritten",
    },
    {
      id: "clinician_gender_missing_alert",
      description: "",
      availability: false,
      label_name: "Clinician Gender Missing",
    },
    {
      id: "pending_refunds_alert",
      description: "",
      availability: false,
      label_name: "Pending Refunds",
    },
    {
      id: "preference_conflict_alert",
      description: "",
      availability: false,
      label_name: "Clinician Availability vs Appointment Preference Alert",
    },
  ]);
  const appointmentDataActual = calenderData;
  const filteredData = useMemo(() => {
    if (!searchPatientInput) return [];
    // console.log('::::::::::filteredData::::::::')
    return searchData?.data;
  }, [searchData]);

  //     useEffect(() => {
  //     const fetchPublicKey = async () => {
  //       try {
  //         const response = await axios.get(`${Config.url}get-payment-keys`, {
  //           headers: {
  //             'Content-Type': 'application/json',
  //             'Authorization': `Bearer ${localStorage.getItem('token')}`
  //           }
  //         });
  //         // Assuming you want the first key in the array
  //         const key = response?.data?.data?.[0]?.public_key;
  //         // console.log('Fetched public key:', key);
  //         if (key) setPublicKey(key);
  //       } catch (error) {
  //         console.log('Error fetching public key:', error);
  //       }
  //     };
  //     fetchPublicKey();
  //   }, []);
  //   const stripePromise = publicKey
  //     ? loadStripe(publicKey)
  //     : null;

  useEffect(() => {
    if (!clinicSelected?.id) return;
    if (debouncedInputValueData) {
      let payload = {
        clinic_id: clinicSelected.id,
        date: selectedDate,
      };
      if (isTypeWeek && weekRange && weekRange.length) {
        payload.date = weekRange[0];
        payload.end_date = weekRange[6];
      }
      payload.search_value = `${debouncedInputValueData}`;
      payload.offset = 0;
      getAllCsrDataByApi(payload);
    } else {
      if (!debouncedInputValueData) {
        // console.log('useEffect getAllDataBYApi :debouncedInputValueData:', debouncedInputValueData)
        getAllDataBYApi(clinicSelected.id, selectedDate);
      }
    }
  }, [debouncedInputValueData]); //weekRange

  useEffect(() => {
    if (location?.state?.date) {
      const momentObj = moment(location.state.date, "YYYY-MM-DD");
      if (momentObj.isValid()) {
        // onSelect(momentObj, null, null, 'day');
      }
    }
  }, [location?.state?.date]);

  const getAllCsrDataByApi = async (data) => {
    // setloaderCalender(true)
    setsearchLoading(true);
    // console.log('getAllCsrDataByApi full week ', data)
    let payload = {
      keyword: data.search_value,
      offset: data.offset,
    };
    // let url = ` https://api.ldcbe.webdezign.uk/api/admin/v1/search-calendar?keyword=07880&offset=0`
    // return
    let csrRoomData = await spacerData("search-calendar", payload);
    let addMoredata;
    if (searchData && searchData.data && searchData.data.length) {
      addMoredata = searchData.data;
    }
    if (
      searchData &&
      searchData.data &&
      searchData.data.length &&
      data.offset != 0
    ) {
      setsearchData((pre) => ({
        ...csrRoomData.data,
        data: [...pre.data, ...csrRoomData.data.data],
      }));
    } else {
      setsearchData(csrRoomData.data);
    }
    if (
      data.offset == 0 &&
      csrRoomData.data.data &&
      csrRoomData.data.data.length == 0
    ) {
      messageApi.error({
        type: "error",
        content: "No Data",
      });
    }
    // let csrRoomData = await spacerData('patient/search', data)
    // console.log(' getAllCsrDataByApi', csrRoomData)
    // setappointmentData(csrRoomData?.data?.data)

    // setloaderCalender(false)
    setsearchLoading(false);
  };

  const getBankHolidaysByApi = async () => {
    try {
      const response = await axios.get(`${Config.url}bank-holidays`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      const responseData = response?.data?.data;
      const holidayList = Array.isArray(responseData)
        ? responseData
        : Array.isArray(responseData?.data)
          ? responseData.data
          : [];

      const holidayMap = {};
      holidayList.forEach((item) => {
        const statusValue = item?.is_active ?? item?.status;
        const normalizedStatus =
          typeof statusValue === "string"
            ? statusValue.trim().toLowerCase()
            : statusValue;
        const isActiveHoliday =
          normalizedStatus === true ||
          normalizedStatus === 1 ||
          normalizedStatus === "1" ||
          normalizedStatus === "active" ||
          normalizedStatus === "true";

        if (!isActiveHoliday) {
          return;
        }

        const rawDate = item?.holiday_date || item?.date;
        if (!rawDate) {
          return;
        }

        const formattedDate = moment(rawDate).format("YYYY-MM-DD");
        const holidayName = item?.name || item?.holiday_name || "Bank Holiday";

        if (!holidayMap[formattedDate]) {
          holidayMap[formattedDate] = [];
        }
        holidayMap[formattedDate].push(holidayName);
      });

      setBankHolidayByDate(holidayMap);
    } catch (error) {
      console.log("getBankHolidaysByApi error :::", error);
    }
  };



  useEffect(() => {
    if (incomingDate !== today) {
      navigate(location.pathname, {
        state: { ...location.state, date: today },
        replace: true,
      });
    }
    if (!hasFetched.current) {
      getAllClinicData();
      // getAllDataBYApi(clinicSelected.id, selectedDate)
      getAllHealthScreenDataByApi(1);
      getAllProductData(1);
      getAlllunchAndSpacerData(1);
      getBankHolidaysByApi();
      conflictAlerts();
      // IOO-275: session settings now fetched inside the hook on startSession()
      hasFetched.current = true;
    }
  }, []);
  // Add this inside your ClinicCalendarPage component
  useEffect(() => {
    // Call once immediately
    conflictAlerts();
    // Set interval to call every 3 minutes
    const interval = setInterval(() => {
      conflictAlerts();
    }, 180000); // 180,000 ms = 3 minutes

    // Cleanup on unmount / clinic change
    return () => {
      clearInterval(interval);
      if (conflictAlertsDebounceRef.current) {
        clearTimeout(conflictAlertsDebounceRef.current);
        conflictAlertsDebounceRef.current = null;
      }
    };
  }, [clinicSelected?.id]);
  useEffect(() => {
    if (!clinicSelected?.id) return;
    getAllDataBYApi(clinicSelected.id, selectedDate);
    conflictAlerts(clinicSelected.id);
  }, [selectedDate, weekRange]);

  // IOO-275: Session expiry callback — invoked by the hook when countdown reaches zero.
  // Logs the expiry event, clears localStorage, and resets UI to the appointment step.
  const handleSessionExpiredAdmin = () => {
    const slot_Session = localStorage.getItem('bookingSessionId');
    pushTraceLogEvent({
      event: 'Session Expired',
      payload: {
        step: 'user session expired',
        date: new Date().toISOString().split('T')[0],
        slot_session_id: slot_Session,
      },
      step_status: 'success',
    });
    localStorage.removeItem('bookingSessionId');
    localStorage.removeItem('bookingExpiresAt');
    setShowTimeExpiredModal(true);
    setshowAppoinmentDataDisplay('APPOINMENT');
    setshowAppoinmentData((prev) => ({ ...prev, slot: null }));
    setCurrentStep('');
    setReschedulePreferences(null); // IOO-198: clear rescue preferences on session expiry
  };

  // IOO-275: Wire the booking session hook
  const {
    timeRemaining,
    countdownStartTime,
    showWarningModal: showExtensionWarningModal,
    settings: sessionConfig,
    extensionsUsed: extensionCount,
    maxExtensionsReached,
    startSession,
    stopSession,
    extendSession: handleExtendSession,
    declineExtension: handleDeclineExtension,
  } = useBookingSession(handleSessionExpiredAdmin);

  // ─── Semble cron ID tracking helpers ────────────────────────────────────
  // startCronPolling: activates a 5-second poll for a specific cron run ID.
  // On each tick it checks whether that run is still active.
  // When the run finishes: stops polling, clears localStorage, refreshes calendar.
  const SEMBLE_CRON_LS_KEY = "sembleCronRunId";

  const stopCronPolling = () => {
    clearInterval(cronPollIntervalRef.current);
    cronPollIntervalRef.current = null;
    localStorage.removeItem(SEMBLE_CRON_LS_KEY);
    setCronStatus(null);
    setsyncloader(false);
  };

  const startCronPolling = (trackedId) => {
    // Clear any previous interval before starting a new one
    clearInterval(cronPollIntervalRef.current);

    const tick = async () => {
      try {
        const res = await axios.get(`${Config.url}webjob/status`, {
          params: { cron_name: "semble-cron" },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        const latestRun = res?.data?.data?.latest_run;
        const rawStatus = latestRun?.status ?? null;
        const status = rawStatus ? rawStatus.toLowerCase() : null;
        const runId = latestRun?.id ? String(latestRun.id) : null;

        if (status === "running" && runId === String(trackedId)) {
          // Still running — keep showing the loader
          setCronStatus("running");
        } else {
          // Cron finished (or the run ID changed — something else took over)
          stopCronPolling();
          getAllDataBYApi(clinicSelected.id, selectedDate);
          messageApi.success("Semble sync completed. Calendar refreshed.");
        }
      } catch (_) {
        // Silent fail — keep polling on next tick
      }
    };

    cronPollIntervalRef.current = setInterval(tick, 5000);
  };

  // On mount: check localStorage for a previously tracked cron run.
  // If found and still running with the same ID → resume the loader UI.
  useEffect(() => {
    const resumeIfRunning = async () => {
      const storedId = localStorage.getItem(SEMBLE_CRON_LS_KEY);
      if (!storedId) return; // Nothing to resume

      try {
        const res = await axios.get(`${Config.url}webjob/status`, {
          params: { cron_name: "semble-cron" },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        const latestRun = res?.data?.data?.latest_run;
        const rawStatus = latestRun?.status ?? null;
        const status = rawStatus ? rawStatus.toLowerCase() : null;
        const runId = latestRun?.id ? String(latestRun.id) : null;

        if (status === "running" && runId === String(storedId)) {
          // Same cron still running — resume loader and start polling
          setCronStatus("running");
          startCronPolling(storedId);
        } else {
          // Cron finished while user was away — clean up stale localStorage entry
          localStorage.removeItem(SEMBLE_CRON_LS_KEY);
        }
      } catch (_) {
        // Silent fail — don't show loader if status check fails
        localStorage.removeItem(SEMBLE_CRON_LS_KEY);
      }
    };

    resumeIfRunning();

    // Cleanup: clear polling interval when component unmounts
    return () => {
      clearInterval(cronPollIntervalRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // ─────────────────────────────────────────────────────────────────────────

  const mergeConflictAlertsData = (conflictAlertsData, data) => {
    return conflictAlertsData.map((item) => {
      // Find matching key in data object
      const match = data[item.id];
      if (match) {
        // Merge properties from data[key] into the array item
        return { ...item, ...match, id: item.id };
      }
      // If no match, return the original item
      return item;
    });
  };
  // Each type is requested in its own call (rather than one unfiltered call that makes
  // the backend compute all 5 alert types in a single request) to avoid the conflict-alerts
  // timeout — see IOO-388.
  const CONFLICT_ALERT_TYPES = [
    { type: "clinician", key: "clinician_availability_conflict_alert" },
    { type: "spacer", key: "spacers_overwritten_alert" },
    { type: "gender", key: "clinician_gender_missing_alert" },
    { type: "refund", key: "pending_refunds_alert" },
    { type: "preference", key: "preference_conflict_alert" },
  ];
  const runConflictAlertsFetch = async () => {
    // Skip if a fetch is already in flight — protects against the 3-min interval (or a
    // late-firing effect) overlapping a still-pending fetch.
    if (conflictAlertsInFlightRef.current) {
      return;
    }
    conflictAlertsInFlightRef.current = true;

    try {
      const responses = await Promise.all(
        CONFLICT_ALERT_TYPES.map(({ type }) => spacerData("conflict-alerts", { type })),
      );

      // Each response fully computes only the requested type; the other 4 keys come back
      // as the fixed empty placeholder shape, so only pick the requested type's key out of
      // each response rather than merging the whole response object.
      const mergedData = {};
      responses.forEach((response, index) => {
        const { key } = CONFLICT_ALERT_TYPES[index];
        if (response?.data?.[key]) {
          mergedData[key] = response.data[key];
        }
      });

      const mergedConflictAlertsData = mergeConflictAlertsData(
        conflictAlertsData,
        mergedData,
      );
      setconflictAlertsData(mergedConflictAlertsData);
    } finally {
      conflictAlertsInFlightRef.current = false;
    }
  };

  // Debounces bursts of near-simultaneous callers (mount, clinicSelected effect,
  // selectedDate/weekRange effect can all fire within the same initial-load sequence)
  // into a single fetch. No caller awaits conflictAlerts() today, so this stays fire-and-forget.
  const conflictAlerts = () => {
    if (conflictAlertsDebounceRef.current) {
      clearTimeout(conflictAlertsDebounceRef.current);
    }
    conflictAlertsDebounceRef.current = setTimeout(() => {
      conflictAlertsDebounceRef.current = null;
      runConflictAlertsFetch();
    }, 150);
  };

  function convertToDateFormat(dateInput) {
    const momentDate = moment(dateInput);

    if (momentDate.isValid()) {
      return momentDate.format("YYYY-MM-DD");
    } else {
      console.error("Invalid date");
      return null;
    }
  }

  const getAllHealthScreenDataByApi = async (CurrentPage) => {
    setloader(true);
    try {
      const response = await axios.get(
        // per_page=-1 fetches ALL products in one shot (same pattern as product-category/page/1?per_page=-1)
        // Without this, Women Health / Dental Care products (high IDs) would be on page 2+ and missing.
        `${Config.url}non-gp-products/page/${CurrentPage}?per_page=-1`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      setgetAllHealthScreenData(response?.data?.data);
      // Persist to localStorage so the next open is instant
      try {
        localStorage.setItem('ldc_nonGpProducts_cache', JSON.stringify({
          data: response?.data?.data,
          ts: Date.now(),
        }));
      } catch { /* quota exceeded — non-fatal */ }
      setloader(false);
      hasFetched.current = false;
    } catch (error) {
      console.log("error in get non-gp-products data ::::", error);
      messageApi.error({
        type: "error",
        content:
          error.response?.data?.message ||
          error.message ||
          "Something went wrong",
      });
      setloader(false);
    }
  };
  const getAllDataBYApi = async (id, date = moment().format("YYYY-MM-DD")) => {
    setloaderCalender(true);
    let newDate = convertToDateFormat(date);
    // console.log({ id, date }, ' getAllDataBYApi', newDate)
    let data = {
      clinic_id: id,
      date: newDate,
    };
    if (isTypeWeek && weekRange && weekRange.length) {
      data.date = weekRange[0];
      data.end_date = weekRange[6];
    }
    // return
    let csrRoomData = await spacerData("csr-rooms", data);
    let lantumStartAndEndDate = {};
    if (csrRoomData?.data?.data && csrRoomData?.data?.data.length) {
      csrRoomData?.data?.data.map((newData) => {
        if (newData && newData.rooms && newData.rooms) {
          newData.rooms.map((roomdata) => {
            if (
              roomdata &&
              roomdata.type &&
              roomdata.room_id &&
              roomdata.type === "lantum"
            ) {
              lantumStartAndEndDate[roomdata.room_id] = {
                ...roomdata,
                clinic_id: clinicSelected.id,
              };
            }
          });
        }
      });
    }
    // console.log('lantumStartAndEndDate', lantumStartAndEndDate)
    setlantumStartAndEndDate(lantumStartAndEndDate);
    setappointmentData(csrRoomData?.data?.data);
    setloaderCalender(false);
  };
  const getAllProductData = async (CurrentPage, searchValue = null) => {
    if (!CurrentPage) {
      return;
    }
    setloader(true);
    try {
      let url = `${Config.url}gp-product/page/${CurrentPage}`;
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setloader(false);
      // console.log('gp-product ::::', response?.data?.data)
      setallGPproduct(response?.data?.data?.data);
      hasFetched.current = false;
    } catch (error) {
      console.log("error in gp-product ::::", error);
      messageApi.error({
        type: "error",
        content:
          error.response?.data?.message ||
          error.message ||
          "Something went wrong",
      });
      setloader(false);
    }
    setloader(false);
  };

  const getAlllunchAndSpacerData = async (CurrentPage) => {
    if (!CurrentPage) {
      return;
    }
    setloader(true);
    try {
      let url = `${Config.url}spacer/page/${CurrentPage}`;
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setloader(false);
      // console.log('spacer ::::', response?.data?.data?.data)
    } catch (error) {
      console.log("error in spacer ::::", error);
      messageApi.error({
        type: "error",
        content:
          error.response?.data?.message ||
          error.message ||
          "Something went wrong",
      });
      setloader(false);
    }
    setloader(false);
  };

  const getAllClinicData = async () => {
    setloader(true);
    try {
      const response = await axios.get(`${Config.url}clinic?per_page=-1`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      // console.log('response?.data?.data ::::', response?.data?.data)
      setallClinicData(response?.data?.data?.data);
      hasFetched.current = false;
      setloader(false);
    } catch (error) {
      console.log("error in get clinic data ::::", error);
      setloader(false);
      messageApi.error({
        type: "error",
        content:
          error.response?.data?.message ||
          error.message ||
          "Something went wrong",
      });
    }
  };

  const { token } = theme.useToken();
  const onPanelDateChange = (value, mode) => {
    // console.log(value.format('YYYY-MM-DD hh:mm a'), mode);
  };
  const wrapperStyle = {
    maxWidth: 300,
    border: `1px solid ${token.colorBorderSecondary}`,
    borderRadius: token.borderRadiusLG,
  };

  const onClose = (data) => {
    setmodalStatus(false);
  };
  // IOO-198: Always show the preference step for all categories (GP, d2c, corporate)
  // so language & gender are always editable during reschedule.
  const shouldShowPreferenceStep = (apptData) => {
    return !!apptData;
  };

  const onSubmit = (data) => {
    if (data && data.type && data.type == "CANCEL") {
      getAllDataBYApi(clinicSelected.id, selectedDate);
      conflictAlerts();

      setmodalStatus(false);
      setOpen(true);
      return;
    }
    if (data && data.type && data.type == "UPDATE") {
      getAllDataBYApi(clinicSelected.id, selectedDate);
      setmodalStatus(false);
      // messageApi.success({
      //   type: "success",
      //   content: "Appointment notes added successfully",
      // });
      return;
    }

    // console.log('::::data', data)
    console.trace("[scroll-debug] onSubmit (reschedule) scrolling to .createAppointment, data=", data);
    setTimeout(() => {
      document
        .querySelector(".createAppointment")
        ?.scrollIntoView({ behavior: "smooth" });
    }, 100);
    setshowAppoinmentData({ ...data.data, isUpdate: true });
    // setshowAppoinmentData(pre => ({ ...pre, ...data.data, isUpdate: true }))

    // IOO-198: For RESCHEDULE, enrich with selectedProduct (needed for Non-GP
    // allow_language_selection / allow_gender_selection flags in BookingForm)
    const _reschedProductId = data?.data?.clinic?.non_gp_product_id;
    const _reschedProduct = _reschedProductId
      ? (Array.isArray(getAllHealthScreenData) ? getAllHealthScreenData : []).find(
        (p) => String(p.non_gp_product_id) === String(_reschedProductId)
      ) || null
      : null;
    if (_reschedProduct) {
      setshowAppoinmentData((prev) => ({ ...prev, selectedProduct: _reschedProduct }));
    }
    const _reschedCat = data?.data?.clinic?.productCategory;

    // IOO-198: Route to ReschedulePreferenceStep when preferences are configurable;
    // otherwise fall straight through to PreferredTime (existing behaviour).
    setshowAppoinmentDataDisplay(
      shouldShowPreferenceStep(data?.data?.data, _reschedCat, _reschedProduct)
        ? "ReschedulePreferenceStep"
        : "PreferredTime"
    );
    setReschedulePreferences(null); // always reset on new reschedule

    setmodalStatus(false);
    resetCouponState();
    // setOpen(true);   //test
  };
  const openModal = (el, data) => {
    // console.log('data?._def?.extendedProps?.data:', data?._def?.extendedProps?.data);
    if (
      data?._def?.extendedProps?.data &&
      data?._def?.extendedProps?.data.type &&
      data?._def?.extendedProps?.data.type == "appointment"
    ) {
      if (el && typeof el.getBoundingClientRect === "function") {
        const rect = el.getBoundingClientRect();
        const screenWidth = window.innerWidth;
        const isBefore = rect.left < screenWidth / 2;
        data.isBefore = isBefore;
        setmodalStatus(true);
        setcalenderData(data._def.extendedProps.data);
        setOpen(false);

        setshowAppoinmentDataDisplay("APPOINMENT");
      } else {
        console.warn("Invalid DOM element passed to openModal:", el);
      }
    } else {
      let payload =
        data?._def?.extendedProps?.data?.type == "spacer"
          ? "SPACER"
          : data?._def?.extendedProps?.data?.type == "lunch"
            ? "lunch"
            : "BLOCK"; //item.type === "lunch" || item.type === "spacer"
      //    console.log('payload:::',payload)
      setshowAppoinmentData(null);
      setshowAppoinmentDataDisplay(payload);
      setappointmentType(true);
      setspacerAndLunch(data?._def?.extendedProps?.data);
    }
  };

  const callbackAppointment = (data, type = null) => {
    if (!data) {
      return;
    }
    resetCouponState();
    if (data?.nexData == "data") {
    } else {
      setshowAppoinmentData((priviousData) => ({
        ...priviousData,
        clinic: data,
        selectedProduct: data.productData || null,
      }));
    }
    if (type) {
      setshowAppoinmentDataDisplay(type);
    }
  };

  // Populate the patient-details form from any existing patient data, then
  // advance straight to the patient-details step. Shared by
  // callbackClinicBooking / callbackPreferredTime — their Continue buttons
  // block the slot and hand off here directly, skipping the old "confirm
  // your booking" screen (BookingDetailsNext rendered as its own step) that
  // used to sit between slot selection and patient details for every
  // booking/reschedule scenario and category type.
  const goToPatientDetails = () => {
    if (calenderData.patient && calenderData.patient.first_name) {
      form.setFieldsValue({
        first_name: "",
        last_name: "",
        date_of_birth: "",
        email: "",
        comment: "",
        terms: "",
        marketing: "",
        mobile_number: "",
        ...calenderData.patient,
        postalCode:
          calenderData.patient.postal_code ||
          calenderData.patient.postalCode ||
          calenderData.postal_code ||
          calenderData.postalCode ||
          showAppoinmentData?.data?.postal_code ||
          showAppoinmentData?.data?.postalCode ||
          "",
        postalCode1:
          calenderData.patient.postal_code ||
          calenderData.patient.postalCode ||
          calenderData.postal_code ||
          calenderData.postalCode ||
          showAppoinmentData?.data?.postal_code ||
          showAppoinmentData?.data?.postalCode ||
          "",
        comment: calenderData?.notes ?? "",
        date_of_birth: moment(
          calenderData.patient.date_of_birth,
          "YYYY-MM-DD",
        ),
        // Select's Options use gp_product_id.toString() as their value —
        // normalize so the raw (possibly numeric) stored reason matches.
        appointment_reason:
          calenderData.patient.appointment_reason != null
            ? String(calenderData.patient.appointment_reason)
            : undefined,
      });
    } else {
      resetPatientForm();
    }
    setshowAppoinmentDataDisplay("BookingDetailsNext");
  };
  const callbackClinicBooking = (data, type = null) => {
    if (!data) {
      return;
    }
    setshowAppoinmentData((priviousData) => ({ ...priviousData, ...data }));
    if (type === "AppointmentSelection") {
      // ClinicBooking.js's own Continue button already blocked the slot —
      // start the hold countdown and skip straight to patient details.
      startSession();
      const sid = localStorage.getItem('bookingSessionId');
      if (sid && sid !== 'undefined') setBookingSessionId(sid);
      goToPatientDetails();
    } else if (type) {
      setshowAppoinmentDataDisplay(type);
    }
  };
  const callbackPreferredTime = (data, type = null) => {
    if (!data) {
      return;
    }
    if (data?.nexData == "data") {
    } else {
      setshowAppoinmentData((priviousData) => ({ ...priviousData, ...data }));
    }
    if (type === "AppointmentSelection") {
      // PreferredTime.js's own Continue button already blocked the slot —
      // start the hold countdown and skip straight to patient details.
      // (PreferredTime.js is shared by new bookings and reschedules alike.)
      startSession();
      const sid = localStorage.getItem('bookingSessionId');
      if (sid && sid !== 'undefined') setBookingSessionId(sid);
      goToPatientDetails();
    } else if (type) {
      setshowAppoinmentDataDisplay(type);
    }
  };
  const callbackBookingDetailsNext = (data, type = null) => {
    if (!type) {
      return;
    }
    goToPatientDetails();
  };
  const callbackBookingForm = (data, type = null) => {
    if (!data) {
      return;
    }
    // console.log('callbackBookingForm::::::', { showAppoinmentData, data })
    // return
    setshowAppoinmentData((priviousData) => ({ ...priviousData, ...data }));
    if (type) {
      setshowAppoinmentDataDisplay(type);
    }
  };

  // IOO-198: Callback from the ReschedulePreferenceStep.
  // Merges updated gender/language into showAppoinmentData at BOTH the top level
  // AND clinic.calenderData (which PreferredTime.js reads via effectiveGender logic
  // at line 469-471 when isReshedula is true), then advances to slot selection.
  const callbackRescheduleBookingForm = (formData, type) => {
    if (!formData) return;
    // Resolve language { label, value } from languageData
    const langObj = location.state?.languageData?.find(
      (l) => String(l.value) === String(formData.language?.value ?? formData.language)
    );
    const newPrefs = {
      gender: formData.gender ?? 'no_preference',
      language: String(formData.language?.value ?? formData.language ?? '1'),
      selectedLanguage: {
        label: langObj?.label || 'English',
        value: formData.language?.value ?? formData.language,
      },
      duration: formData.duration,
    };
    setReschedulePreferences(newPrefs);
    // Patch both levels so every downstream consumer picks up the updated values
    setshowAppoinmentData((prev) => ({
      ...prev,
      gender: newPrefs.gender,
      language: newPrefs.language,
      selectedLanguage: newPrefs.selectedLanguage,
      clinic: {
        ...prev.clinic,
        calenderData: {
          ...prev.clinic?.calenderData,
          preferred_gender: newPrefs.gender,   // PreferredTime.effectiveGender reads this
          language_id: newPrefs.language,  // PreferredTime language reads this
        },
      },
    }));
    setshowAppoinmentDataDisplay('PreferredTime');
  };

  const onSelect = (date, newdata, type, isday) => {
    const formattedDate = moment(date.$d || date._d).format("YYYY-MM-DD");
    // console.log(formattedDate, '::onSelect::', { date, newdata, type, isday })
    if ((isTypeWeek || type == "Week") && !isday) {
      const start = date.clone().startOf("week");
      const fullWeek = [];
      if (start?._isAMomentObject) {
        for (let i = 0; i < 8; i++) {
          if (i == 0) {
            continue;
          }
          fullWeek?.push(start?.clone()?.add(i, "day")?.format("YYYY-MM-DD"));
        }
      } else {
        for (let i = 0; i < 7; i++) {
          fullWeek.push(start?.clone()?.add(i, "day")?.format("YYYY-MM-DD"));
        }
      }
      // console.log('fullWeek', fullWeek);
      // console.log("selected date and new ",selectedDate,formattedDate)
      setWeekRange(fullWeek);
      setSelectedDate(formattedDate);
    } else {
      // console.log('selected date and new ',selectedDate,formattedDate)
      setSelectedDate(formattedDate);
      setisTypeWeek(false);
      setWeekRange([]);
    }
  };

  const dateCellRender = (date) => {
    let isSelected = false;
    const calendarDate = date.format("YYYY-MM-DD");
    const holidayNames = bankHolidayByDate[calendarDate] || [];
    const isBankHoliday = holidayNames.length > 0;

    if (isTypeWeek && weekRange?.length) {
      isSelected = weekRange.includes(calendarDate);
    } else {
      isSelected = selectedDate === calendarDate;
    }

    const dateCellContent = (
      <div
        className="custom-date"
        style={{
          height: 30,
          width: 30,
          margin: "auto",
          borderRadius: "50%",
          backgroundColor: isSelected
            ? "#008385"
            : isBankHoliday
              ? "#ffd7ed"
              : undefined,
          color: isSelected ? "#fff" : undefined,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {date.date()}
      </div>
    );

    if (isBankHoliday) {
      return <Tooltip title={holidayNames.join(", ")} color="#008385">{dateCellContent}</Tooltip>;
    }

    return dateCellContent;
  };
  // Shared by createAppointment/getDataFrom — clears the previous booking's
  // patient/clinic/slot data and patient-details form fields so a new booking
  // never inherits a prior one's values. patientFormKey also bumps so
  // Patientdetails remounts (its dob/phone display state is local, not
  // driven by the Form store, so setFieldsValue alone can't clear it).
  const resetPatientBookingFields = () => {
    setshowAppoinmentData(null);
    setcalenderData({});
    setCouponDiscount(0);
    setCouponApplied(false);
    setCouponCode("");
    setPromoCodeId(null);
    setShowCouponInput(false);
    setPatientFormKey((k) => k + 1);
    form.setFieldsValue({
      first_name: "",
      last_name: "",
      gender: undefined,
      date_of_birth: "",
      email: "",
      phone: "",
      country_code: "",
      mobile_number: "",
      address_1: "",
      address_2: "",
      city: "",
      country: undefined,
      postalCode1: "",
      appointment_reason: undefined,
      comment: "",
      terms: "",
      marketing: "",
      cardHolderName: undefined,
    });
  };
  const createAppointment = () => {
    // Clear any active booking session when initiating a new Create action.
    // trace_log_id is NOT cleared here — it's a whole-journey analytics session
    // (seeded once when the booking journey opens) and isn't regenerated once
    // cleared, so wiping it here would leave session_id null on the eventual
    // booking submission.
    stopCountdown();
    localStorage.removeItem("bookingSessionId");
    localStorage.removeItem("bookingExpiresAt");
    resetPatientBookingFields();

    if (
      showAppoinmentDataDisplay == "LUNCH" ||
      showAppoinmentDataDisplay == "SPACER" ||
      showAppoinmentDataDisplay == "BLOCK"
    ) {
      setappointmentType(true);
    } else {
      console.trace("[scroll-debug] createAppointment() scrolling to .createAppointment");
      document
        .querySelector(".createAppointment")
        ?.scrollIntoView({ behavior: "smooth" });
      setappointmentType(false);
    }
  };
  const callbackLunchAndSpacer = (data) => {
    seterrorMessage();
    if (data?.dataClear) {
      return;
    }
    if (data?.modalClose) {
      setappointmentType(false);
      setspacerAndLunch(null);
    }
    if (data?.type) {
      getAllDataBYApi(clinicSelected.id, selectedDate);
      conflictAlerts();
    }
  };
  const createSpaceAndLunch = async (data) => {
    // let updateUrl = 'spacer'
    // // return
    // if (data && data.type && data.type == 'block') {
    //     updateUrl = 'block'
    // } else {
    //     updateUrl = 'spacer'
    // }

    // console.log('API payload received:', data);

    let updateUrl = "spacer";
    if (data && data.type && data.type === "block") {
      updateUrl = "block";
    } else {
      updateUrl = "spacer";
    }

    if (data && data.typedata && data.typedata == "update") {
      let url = `${Config.url}${updateUrl}/${data.id}`;
      try {
        const response = await axios.put(
          url,
          {
            ...data,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        messageApi.success({
          type: "succes",
          content: `${data.type} updated successfully`,
        });
        setappointmentType(false);
        getAllDataBYApi(clinicSelected.id, selectedDate);
        conflictAlerts();
        seterrorMessage();
      } catch (error) {
        messageApi.error({
          type: "error",
          content:
            error.response?.data?.message ||
            error.message ||
            "Something Went wrong",
        });
        if (error.response?.data?.message === "Validation failed") {
          const errorsObj = error?.response?.data?.errors || {};
          const errorString = Object.entries(errorsObj)
            .map(([field, messages]) => {
              const fieldName = field.charAt(0).toUpperCase() + field.slice(1);
              return `${fieldName} : ${messages.join(", ")}`;
            })
            .join("\n");

          seterrorMessage(errorString);
        } else {
          seterrorMessage(error.response?.data?.message || error.message);
        }
        // setOpen(true);  //test
        setappointmentType(true);
        // console.log('update user:', error.response?.data?.message || error.message);
      }
    } else {
      try {
        const response = await axios.post(
          `${Config.url}${updateUrl}`,
          {
            ...data,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        if (response) {
          setappointmentType(false);
          getAllDataBYApi(clinicSelected.id, selectedDate);
          conflictAlerts();
          seterrorMessage();
          messageApi.success({
            type: "succes",
            content: `${data.type} created successfully`,
          });
        }
      } catch (error) {
        setappointmentType(false);
        messageApi.error({
          type: "error",
          content:
            error.response?.data?.message ||
            error.message ||
            "Something Went wrong",
        });
        setappointmentType(true);
        if (error.response?.data?.message === "Validation failed") {
          const errorsObj = error?.response?.data?.errors || {};
          const errorString = Object.entries(errorsObj)
            .map(([field, messages]) => {
              const fieldName = field.charAt(0).toUpperCase() + field.slice(1);
              return `${fieldName} : ${messages.join(", ")}`;
            })
            .join("\n");

          seterrorMessage(errorString);
        } else {
          seterrorMessage(error.response?.data?.message || error.message);
        }
        // console.log('create user:', error.response?.data || error.message);
      }
    }
  };
  const callbackAppointmentSelection = (data, type = null) => {
    // console.log('callbackAppointmentSelection data:', data, type);
    if (type) {
      setshowAppoinmentDataDisplay(type);
      // IOO-275: start the booking countdown via the hook
      startSession();
      // IOO-275: sync bookingSessionId state so ClinicBooking re-fetches with slot_session_id
      const sid = localStorage.getItem('bookingSessionId');
      if (sid && sid !== 'undefined') setBookingSessionId(sid);
      if (type === "BookingDetailsNext") {
        setCurrentStep(type);
      }
    }
    if (!showAppoinmentData?.slot || showAppoinmentData?.slot?.id !== data?.id) {
      resetCouponState();
      if (!calenderData?.patient) {
        resetPatientForm();
      }
    }
    setshowAppoinmentData((priviousData) => ({ ...priviousData, slot: data }));
  };
  const handleClinicSelect = (value) => {
    let data = allClinicData.find((item) => item.id == value);
    if (data) {
      getAllDataBYApi(value, selectedDate);
      setclinicSelected(data);
      conflictAlerts(data.id);
      // console.log('location :::', location)
      navigate(location.pathname, {
        state: {
          ...location.state, // keep existing state
          clinic: data, // update clinic
        },
        replace: true, // optional: prevents adding a new entry to browser history
      });
    }
  };
  const createNewAppointment = (data) => {
    if (data.resource && data.resource.id) {
      clinicSelected.roomId = data.resource.id;
    }
    createAppointment();
  };

  const handleOpenChange = (newOpen) => {
    if (newOpen) {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
    // setshowAppoinmentDataDisplay('');
  };
  // IOO-275: stopCountdown is now stopSession() from the useBookingSession hook.
  // Kept as a named alias here for any existing call sites that reference it.
  const stopCountdown = stopSession;

  // IOO-307: Open Room Swap Modal when a room header is clicked in CalendarOneDay
  const handleRoomHeaderClick = (roomData) => {
    setSwapSourceRoom(roomData);
    setRoomSwapModalVisible(true);
  };

  // IOO-307: Called on successful swap — refresh the calendar
  const handleSwapSuccess = () => {
    getAllDataBYApi(clinicSelected.id, selectedDate);
    conflictAlerts();
  };

  // IOO-275: handleExtendSession and handleDeclineExtension are now provided by
  // useBookingSession hook (destructured above as handleExtendSession / handleDeclineExtension).

  // IOO-275: Countdown Display Component with colour transitions
  const CountdownDisplay = () => {
    const minutes = Math.floor(timeRemaining / 60000);
    const seconds = Math.floor((timeRemaining % 60000) / 1000);
    const timeString = `${minutes}:${seconds.toString().padStart(2, "0")}`;
    const warningMs = sessionConfig.warning_before_seconds * 1000;
    const badgeColor =
      timeRemaining === 0
        ? '#008385'            // no session yet — show neutral green
        : timeRemaining <= 10000
          ? '#ff4d4f'            // < 10 s — urgent red
          : timeRemaining <= warningMs
            ? '#faad14'            // in warning window — amber
            : '#008385';           // plenty of time — green
    // Derive expiresAt from hook's countdownStartTime + current session duration
    const sessionWindowMs = sessionConfig.duration_seconds * 1000;
    const expiresAt = countdownStartTime && sessionWindowMs > 0
      ? new Date(countdownStartTime + sessionWindowMs)
      : null;
    const expiresLocal12 = expiresAt ? moment(expiresAt).format("HH:mm") : "";

    return (
      <div
        style={{
          marginRight: 10,
        }}
      >
        <Tooltip title={`Expires at ${expiresLocal12}`}>
          <div
            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          >
            <Badge
              count={timeString}
              color={badgeColor}
              style={{ fontSize: 14, marginRight: 6 }}
            />
            <ClockCircleOutlined style={{ fontSize: 20, color: badgeColor }} />
          </div>
        </Tooltip>
      </div>
    );
  };

  // IOO-275: Handle time expired modal OK button.
  // Calls stopSession() (via hook) to clear all timer state and removes the
  // stale bookingSessionId so the next booking starts fresh.
  const handleTimeExpiredOk = () => {
    setShowTimeExpiredModal(false);
    stopSession();                               // clear hook timer state
    localStorage.removeItem('bookingSessionId'); // clear stale session ID
    localStorage.removeItem('bookingExpiresAt');
    setshowAppoinmentDataDisplay('APPOINMENT');
    setshowAppoinmentData((prev) => ({ ...prev, slot: null }));
    setCurrentStep('');
    setReschedulePreferences(null); // IOO-198: clear reschedule preferences on expiry
  };

  // setformloading(false)
  const handleSubmitFailed = (errorInfo) => {
    console.log("Form Submission Failed:", errorInfo);
    // Scroll to the first field with a validation error
    try {
      const firstErrorField = errorInfo?.errorFields?.[0]?.name?.[0];
      if (firstErrorField) {
        // For the phone field, target the actual PhoneInput element
        let el =
          document.getElementById(`patient_details_${firstErrorField}`) ||
          document.getElementById(firstErrorField) ||
          document.querySelector(`[id$="_${firstErrorField}"]`);

        if (!el) {
          // Fallback: first error Form.Item wrapper — then find its input inside
          const firstErrorItem = document.querySelector(".ant-form-item-has-error");
          if (firstErrorItem) {
            el = firstErrorItem.querySelector("input") || firstErrorItem;
          }
        }

        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          if (typeof el.focus === "function") el.focus({ preventScroll: true });
        }
      } else {
        // Fallback: scroll to the first visible error in the DOM
        const firstError = document.querySelector(".ant-form-item-has-error");
        if (firstError) {
          firstError.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
    } catch (_) { }
  };
  const onFinish = async (values) => {
    //    console.log("onFinish::",showAppoinmentData?.selectedProduct?.pre_payment_enabled)
    setformloading(true);
    // return;
    const _catType1299 = (
      showAppoinmentData?.clinic?.productCategory?.type ||
      (showAppoinmentData?.clinic?.productCategory?.product_category_id == 3 ? 'corporate' :
        showAppoinmentData?.clinic?.productCategory?.product_category_id == 1 ? 'gp' : 'd2c')
    );
    if (
      _catType1299 === 'corporate' &&
      !showAppoinmentData?.selectedProduct?.pre_payment_enabled
    ) {
      corporateAppoiment(values);
      return;
    }
    // console.log('SuisDifferentCardHolderccess:', isDifferentCardHolder);
    // return

    // Validate postal code if provided
    // if (values.postalCode?.trim() && !isPostalCode(values.postalCode?.trim(), 'GB')) {
    //     messageApi.error({
    //         type: 'error',
    //         content: 'Please enter a valid UK postal code',
    //     });
    //     setformloading(false);
    //     return;
    // }
    if ((!showAppoinmentData?.clinic?.isChargesOverRide && !showAppoinmentData?.clinic?.isAdditionalChargesOverridden) || showAppoinmentData?.slot?.info?.additional_charges) {
      // Get current country from form values
      const country = values.country || "UK";
      const postalCode =
        values.postalCode?.trim() || values.postalCode1?.trim();
      // Validate postal code based on country
      let postalCodeValid = false;
      if (country === "UK") {
        postalCodeValid =
          isPostalCode(postalCode, "GB") ||
          specialPostcodes.includes(postalCode.toUpperCase());
      } else if (country === "US") {
        postalCodeValid = isPostalCode(postalCode, "US");
      } else if (country === "CA") {
        postalCodeValid = isPostalCode(postalCode, "CA");
      } else {
        postalCodeValid = true; // Skip validation for unknown countries
      }

      if (!postalCodeValid) {
        let errorMessage = "Please enter a valid postal code";
        switch (country) {
          case "UK":
            errorMessage =
              "Please enter a valid UK postcode (e.g. SW1A 1AA)eeeeee";
            break;
          case "US":
            errorMessage =
              "Please enter a valid US ZIP code (e.g. 90210 or 90210-1234)";
            break;
          case "CA":
            errorMessage =
              "Please enter a valid Canadian postal code (e.g. A1A 1A1)";
            break;
        }

        messageApi.error({
          type: "error",
          content: errorMessage,
        });
        pushTraceLogEvent({
          event: "patient_details_validation_failed",
          payload: { validation_error: "invalid_postal_code", country },
          step_status: "failed",
        });
        setformloading(false);
        return;
      }
    }

    if (!hasFullCouponDiscount && ((!showAppoinmentData?.clinic?.isChargesOverRide && !showAppoinmentData?.clinic?.isAdditionalChargesOverridden) || showAppoinmentData?.slot?.info?.additional_charges)) {
      const getCardDetailsExist = await getCardDetails();
      if (!getCardDetailsExist) {
        // messageApi.error({
        //   type: "error",
        //   content: "Enter card details first",
        // });
        pushTraceLogEvent({
          event: "patient_details_validation_failed",
          payload: { validation_error: "card_details_missing" },
          step_status: "failed",
        });
        setformloading(false);
        return;
      }
    }

    if (!values.mobile_number) {
      messageApi.error({
        type: "error",
        content: "Mobile number required",
      });
      setformloading(false);
      return;
    }

    // setformloading(false)
    // return
    let patient = {},
      payload = {
        session_id: session_id,
        cardholder_name: values.cardHolderName
          ? values.cardHolderName.trim()
          : null,
        postal_code: values.postalCode?.trim() || values.postalCode1?.trim() || null,
        corporate_customer_id:
          showAppoinmentData?.clinic?.selectedCorporate?.corporate_customer_id,
      };

    if (
      values.first_name &&
      values.last_name &&
      values.email &&
      values.mobile_number
    ) {
      patient = {
        ...patient,
        first_name: values.first_name,
        last_name: values.last_name,
        email: values.email,
        mobile_number: values.mobile_number,
        date_of_birth: (() => {
          const dob = values.date_of_birth;
          if (!dob) return "";
          // dayjs object
          if (dob && typeof dob.format === "function") return dob.format("YYYY-MM-DD");
          // native Date (dayjs.$d)
          if (dob instanceof Date) return dayjs(dob).format("YYYY-MM-DD");
          // DD/MM/YYYY string
          if (typeof dob === "string" && dob.includes("/")) return dayjs(dob, "DD/MM/YYYY").format("YYYY-MM-DD");
          // YYYY-MM-DD or ISO string
          return dayjs(dob).format("YYYY-MM-DD");
        })(),
        gender: values.gender,
        member_number: values?.member_number,
        appointment_reason: values.appointment_reason ?? undefined,
        override_spacers: 0,
        address_1: values.address_1,
        address_2: values.address_2,
        city: values.city,
        country_code: values.country_code,
      };
      // "appointment_reason" : "ertet",
      // "comment" : "test",
    }
    if (
      showAppoinmentData &&
      showAppoinmentData.slot &&
      showAppoinmentData.slot.clinicData &&
      showAppoinmentData.slot.clinicData.id
    ) {
      payload = {
        ...payload,
        status: 1,
        clinic_id: showAppoinmentData.slot.clinicData.id,
      };
    }
    // "duration_id": showAppoinmentData?.duration,
    // Derive catType before all blocks so it's in scope for sibling if-statements
    const _catTypePref1 = (
      showAppoinmentData?.clinic?.productCategory?.type ||
      (showAppoinmentData?.clinic?.productCategory?.product_category_id == 1 ? 'gp' :
        showAppoinmentData?.clinic?.productCategory?.product_category_id == 3 ? 'corporate' : 'd2c')
    );
    if (showAppoinmentData) {
      payload = {
        ...payload,
        appointment_type_int: 1,
      };
      // Always add preferred_gender and languages if they were selected
      if (showAppoinmentData.gender && showAppoinmentData.gender !== 'no_preference') {
        payload = {
          ...payload,
          preferred_gender: showAppoinmentData.gender,
        };
      }
      if (showAppoinmentData.language) {
        let lang = showAppoinmentData.language;
        if (
          showAppoinmentData.language &&
          showAppoinmentData.language.value
        ) {
          lang = showAppoinmentData.language.value;
        }
        if (lang) {
          payload = {
            ...payload,
            languages: [lang] ?? [1],
          };
        }
      }
    }
    if (values?.comment) {
      payload = {
        ...payload,
        notes: values?.comment,
      };
    }
    if (
      showAppoinmentData &&
      showAppoinmentData.slot &&
      showAppoinmentData.slot.info &&
      showAppoinmentData.slot.info.start_time
    ) {
      // v2 get-available-slots keys are already real ISO dates (YYYY-MM-DD);
      // date_select was a v1-only field that no longer exists on the slot object.
      const formatted = showAppoinmentData.slot.info?.date_select || showAppoinmentData.slot.date;
      let timeDiff = 15;
      if (
        showAppoinmentData &&
        showAppoinmentData.isUpdate &&
        showAppoinmentData.isUpdate &&
        showAppoinmentData?.data?.duration_id &&
        (_catTypePref1 === 'gp' || showAppoinmentData?.data?.product_category_id == 1)
      ) {
        timeDiff = location.state.durationObjectById[
          showAppoinmentData?.data?.duration_id
        ]
          ? location.state.durationObjectById[
            showAppoinmentData?.data?.duration_id
          ].duration
          : 15;
      } else {
        if (
          location.state &&
          location.state.durationObjectById &&
          showAppoinmentData.duration
        ) {
          timeDiff = location.state.durationObjectById[
            showAppoinmentData.duration
          ]
            ? location.state.durationObjectById[showAppoinmentData.duration]
              .duration
            : 15;
        }
      }
      let endtime = addMinutesToTime(
        showAppoinmentData.slot.info.start_time,
        timeDiff,
      );
      // Non-GP: end_time comes from slot (slots have fixed end time, not calculated from duration)
      if (_catTypePref1 !== 'gp') {
        endtime = showAppoinmentData?.slot?.info?.end_time ?? 15;
      }
      payload = {
        ...payload,
        start_time: `${formatted} ${showAppoinmentData.slot.info.start_time}`,
        end_time: `${formatted} ${endtime}`,
        product_category_id:
          showAppoinmentData?.clinic?.productCategory?.product_category_id ?? 1,
        override_spacers: 0,
      };
      // Non-GP: add product_id + product_category_id; GP: add duration_id
      if (_catTypePref1 !== 'gp') {
        payload = {
          ...payload,
          product_id:
            showAppoinmentData?.clinic?.non_gp_product_id ||
            showAppoinmentData?.non_gp_product_id,
          product_category_id:
            showAppoinmentData?.clinic?.productCategory?.product_category_id ?? null,
        };
      } else {
        payload = {
          ...payload,
          duration_id: showAppoinmentData?.duration,
        };
      }
    }
    if (
      showAppoinmentData.slot &&
      showAppoinmentData.slot?.info &&
      showAppoinmentData.slot?.info.price
    ) {
      payload = {
        ...payload,
        // "charges" is the appointment's original/list price (per the appointments
        // read-endpoint contract, where `charges` and `special_pricing_band.special_price`
        // are separate fields) — send normal_price when a band applies, not the
        // already-discounted slot.info.price. The actual amount charged via Stripe is
        // computed independently in createPayment() using the discounted price, so this
        // change does NOT affect what the patient is billed — only what gets recorded.
        charges: (showAppoinmentData?.slot?.info?.special_pricing_band && showAppoinmentData?.slot?.info?.normal_price != null)
          ? showAppoinmentData.slot.info.normal_price
          : showAppoinmentData.slot?.info.price,
        ...(promoCodeId && { discount_id: promoCodeId }),
        ...(showAppoinmentData?.slot?.info?.special_pricing_band?.id != null && {
          special_pricing_band_id: showAppoinmentData.slot.info.special_pricing_band.id,
        }),
        //   charges: (() => {
        //   const originalAmount = showAppoinmentData.slot?.info.price || 0;
        //   return couponApplied && couponDiscount > 0 
        //     ? originalAmount - couponDiscount 
        //     : originalAmount;
        // })(),
        additional_charges: showAppoinmentData.slot?.info?.additional_charges,
      };
    }
    if (patient && Object.keys(patient).length) {
      payload = {
        ...payload,
        patient,
      };
    }
    if (
      showAppoinmentData &&
      showAppoinmentData.isUpdate &&
      showAppoinmentData.isUpdate &&
      showAppoinmentData.data &&
      showAppoinmentData.data
    ) {
      payload = {
        ...payload,
        // Use the user's updated preference if set, then fall back to the original.
        // Also handles 'female' which the old code missed (only checked 'male').
        preferred_gender: (
          showAppoinmentData.gender && showAppoinmentData.gender !== 'no_preference'
            ? showAppoinmentData.gender
            : (showAppoinmentData.data.preferred_gender || 'no_preference')
        ),
        // "clinic_id": showAppoinmentData.data.clinic_id,
        appointment_type_int: showAppoinmentData.data.appointment_type_int,
        duration_id: showAppoinmentData.data.duration_id ?? undefined,
        status: showAppoinmentData.data.status,
      };
      if (showAppoinmentData.data.duration_id) {
        payload = {
          ...payload,
          duration_id: showAppoinmentData.data.duration_id ?? undefined,
        };
      } else {
        payload = {
          ...payload,
          product_id: showAppoinmentData?.data?.non_gp_product_id,
        };
      }
    }
    if (
      showAppoinmentData &&
      showAppoinmentData.clinic &&
      (showAppoinmentData.clinic.isChargesOverRide || showAppoinmentData.clinic.isAdditionalChargesOverridden)
    ) {
      payload = {
        ...payload,
        override_spacers: 1,
        rescheduling_charge: 0,
        override_additional_charges: showAppoinmentData.clinic.isAdditionalChargesOverridden ? 1 : 0,
      };
    } else {
      payload = {
        ...payload,
        override_spacers: 0,
        rescheduling_charge: showAppoinmentData?.data?.rescheduling_charge ?? 0,
        override_additional_charges: 0,
      };
    }
    // console.log('patient::', patient)
    // console.log('payload::', payload)
    // console.log('showAppoinmentData::', showAppoinmentData)
    // console.log('location.state::', location.state, props)
    // confirmBookinFunction({ ...payload }, 'BookingConfirmation')
    // return
    if (
      showAppoinmentData &&
      showAppoinmentData.isUpdate &&
      showAppoinmentData.isUpdate &&
      showAppoinmentData?.data?.appointment_id
    ) {
      try {
        let url = `${Config.url}appointments/${showAppoinmentData?.data?.appointment_id}`;
        const response = await axios.put(url, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        if (response.data.success) {
          let data = {
            first_name: values.first_name,
            last_name: values.last_name,
            email: values.email,
            mobile_number: values.mobile_number,
            appointment_id: showAppoinmentData?.data?.appointment_id,
            charges: (showAppoinmentData.clinic.isChargesOverRide || showAppoinmentData.clinic.isAdditionalChargesOverridden) ? 0 : showAppoinmentData?.data?.rescheduling_charge,
            product_category_name:
              showAppoinmentData?.data?.product_category_name,
            clinic_id: showAppoinmentData?.data?.clinic_id,
          };
          // console.log('payload::::', payload)
          setholdAppointmentData(data);

          const totalCharges = (showAppoinmentData.clinic.isChargesOverRide || showAppoinmentData.clinic.isAdditionalChargesOverridden) ? 0 : showAppoinmentData?.data?.rescheduling_charge;

          if (
            (totalCharges || showAppoinmentData?.slot?.info?.additional_charges) > 0 && !hasFullCouponDiscount
          ) {
            const paymentResponce = await createPayment(
              data,
              values?.cardHolderName,
              true,
            );
            // console.log('paymentResponce::::', paymentResponce)
            if (paymentResponce) {
              confirmBookinFunction({ ...payload }, "BookingConfirmation");
              getAllDataBYApi(clinicSelected.id, selectedDate);
              handleClose();
              setformloading(false);
            }
          } else {
            gtaCustomEventPush({
              BookedAppointmentPayload: { data },
              paymentIntentResponseCatchPayload: response,
            });
            confirmBookinFunction({ ...payload }, "BookingConfirmation");
            getAllDataBYApi(clinicSelected.id, selectedDate);
            handleClose();
            setformloading(false);
          }

          pushTraceLogEvent({
            event: "payment_initiated",
            payload: {
              step: "Step 4 - Payment Initiated",
              payment_method: selected,
              patient_details: payload,
              is_last_step: true,
              patient_details_filled: true,
            },
            step_status: "success",
          });
        } else {
          messageApi.error({
            type: "error",
            content: response.data.message || "Something Went wrong",
          });
          pushTraceLogEvent({
            event: "appointment_update_failed",
            payload: {
              step: "appointment_update_failed",
              payment_method: selected,
              patient_details: payload,
              is_last_step: true,
              patient_details_filled: true,
              reason: "business_failure",
              response: response.data,
            },
            step_status: "failed",
          });
          setformloading(false);
        }
      } catch (error) {
        console.log("error :::", error);
        pushTraceLogEvent({
          event: "appointment_update_failed",
          payload: {
            step: "appointment_update_failed",
            payment_method: selected,
            patient_details: payload,
            is_last_step: true,
            patient_details_filled: true,
            reason: "exception",
            message: error?.response?.data?.message || error?.message,
          },
          step_status: "failed",
        });
        messageApi.error({
          type: "error",
          content:
            error.response?.data?.message ||
            error.message ||
            "Something Went wrong",
        });
        setformloading(false);
      }
    } else {
      try {
        let url = `${Config.url}appointments`;
        const response = await axios.post(url, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        // console.log('response::::', response)
        setholdAppointmentData({
          ...response.data.data,
          first_name: values.first_name,
          last_name: values.last_name,
          email: values.email,
          mobile_number: values.mobile_number,
        });
        if (response.data.success) {
          if (!hasFullCouponDiscount) {
            const paymentResponce = await createPayment(
              {
                ...response.data.data,
                first_name: values.first_name,
                last_name: values.last_name,
                email: values.email,
                mobile_number: values.mobile_number,
              },
              values?.cardHolderName,
            );

            //  return
            // console.log('paymentResponce::::', paymentResponce)
            if (paymentResponce) {
              getAllDataBYApi(clinicSelected.id, selectedDate);
              confirmBookinFunction({ ...payload }, "BookingConfirmation");
            }
          } else {
            // 100% coupon discount applied - skip payment and confirm directly
            let data = {
              ...response.data.data,
              first_name: values.first_name,
              last_name: values.last_name,
              email: values.email,
              mobile_number: values.mobile_number,
            };
            gtaCustomEventPush({
              BookedAppointmentPayload: { data },
              paymentIntentResponseCatchPayload: response,
            });
            getAllDataBYApi(clinicSelected.id, selectedDate);
            confirmBookinFunction({ ...payload }, "BookingConfirmation");
          }

          pushTraceLogEvent({
            event: "payment_initiated",
            payload: {
              step: "Step 4 - Payment Initiated",
              payment_method: selected,
              patient_details: payload,
              is_last_step: true,
              patient_details_filled: true,
              record_id: response?.data?.data?.appointment_id,
            },
            step_status: "success",
          });
        } else {
          messageApi.error({
            type: "succes",
            content: response.data.message || "Something Went wrong",
          });
          pushTraceLogEvent({
            event: "appointment_book_failed",
            payload: {
              step: "appointment_book_failed",
              payment_method: selected,
              patient_details: payload,
              is_last_step: true,
              patient_details_filled: true,
            },
            step_status: "failed",
          });
        }
        setformloading(false);
      } catch (error) {
        console.log("error :::", error);
        pushTraceLogEvent({
          event: "appointment_book_failed",
          payload: {
            step: "appointment_book_failed",
            payment_method: selected,
            patient_details: payload,
            is_last_step: true,
            patient_details_filled: true,
            reason: "exception",
            message: error?.response?.data?.message || error?.message,
          },
          step_status: "failed",
        });
        messageApi.error({
          type: "succes",
          content:
            error.response?.data?.message ||
            error.message ||
            "Something Went wrong",
        });
        setformloading(false);
      }
    }
    setisDifferentCardHolder(false);
    // setshowAppoinmentData(null)
  };
  const corporateAppoiment = async (values) => {
    console.log("corporateAppoiment", { showAppoinmentData, values });
    setformloading(true);
    if (showAppoinmentData?.clinic?.isChargesOverRide || showAppoinmentData?.slot?.info?.additional_charges) {
      // Get current country from form values
      const country = values?.country || "UK";
      const postalCode = values?.postalCode1;
      // console.log("postalCode",postalCode);

      // Validate postal code based on country
      let postalCodeValid = false;
      if (country === "UK") {
        postalCodeValid =
          isPostalCode(postalCode, "GB") ||
          specialPostcodes.includes(postalCode.toUpperCase());
      } else if (country === "US") {
        postalCodeValid = isPostalCode(postalCode, "US");
      } else if (country === "CA") {
        postalCodeValid = isPostalCode(postalCode, "CA");
      } else {
        postalCodeValid = true; // Skip validation for unknown countries
      }

      if (!postalCodeValid) {
        let errorMessage = "Please enter a valid postal code";
        switch (country) {
          case "UK":
            errorMessage =
              "Please enter a valid UK postcode (e.g. SW1A 1AA)eeeeee";
            break;
          case "US":
            errorMessage =
              "Please enter a valid US ZIP code (e.g. 90210 or 90210-1234)";
            break;
          case "CA":
            errorMessage =
              "Please enter a valid Canadian postal code (e.g. A1A 1A1)";
            break;
        }

        messageApi.error({
          type: "error",
          content: errorMessage,
        });
        setformloading(false);
        return;
      }
    }
    if (!values.mobile_number) {
      messageApi.error({
        type: "error",
        content: "Mobile number required",
      });
      setformloading(false);
      return;
    }
    let patient = {},
      payload = {
        session_id: session_id,
        cardholder_name: values?.cardHolderName
          ? values?.cardHolderName.trim()
          : null,
        postal_code: values.postalCode1?.trim() || null,
        corporate_customer_id:
          showAppoinmentData?.clinic?.selectedCorporate?.corporate_customer_id,
      };
    if (
      values.first_name &&
      values.last_name &&
      values.email &&
      values.mobile_number
    ) {
      patient = {
        ...patient,
        first_name: values.first_name,
        last_name: values.last_name,
        email: values.email,
        mobile_number: values.mobile_number,
        address_1: values.address_1,
        address_2: values.address_2,
        city: values.city,
        country: values.country,
        date_of_birth: (() => {
          const dob = values.date_of_birth;
          if (!dob) return "";
          // dayjs object
          if (dob && typeof dob.format === "function") return dob.format("YYYY-MM-DD");
          // native Date (dayjs.$d)
          if (dob instanceof Date) return dayjs(dob).format("YYYY-MM-DD");
          // DD/MM/YYYY string
          if (typeof dob === "string" && dob.includes("/")) return dayjs(dob, "DD/MM/YYYY").format("YYYY-MM-DD");
          // YYYY-MM-DD or ISO string
          return dayjs(dob).format("YYYY-MM-DD");
        })(),
        gender: values.gender,
        member_number: values?.member_number,
        appointment_reason: values.appointment_reason ?? undefined,
        override_spacers: 0,
        country_code: values.country_code,
      };
      // "appointment_reason" : "ertet",
      // "comment" : "test",
    }
    if (
      showAppoinmentData &&
      showAppoinmentData.slot &&
      showAppoinmentData.slot.clinicData &&
      showAppoinmentData.slot.clinicData.id
    ) {
      payload = {
        ...payload,
        status: 1,
        clinic_id: showAppoinmentData.slot.clinicData.id,
      };
    }
    // "duration_id": showAppoinmentData?.duration,
    // Derive catType before all blocks so it's in scope for sibling if-statements
    const _catTypePref2 = (
      showAppoinmentData?.clinic?.productCategory?.type ||
      (showAppoinmentData?.clinic?.productCategory?.product_category_id == 1 ? 'gp' :
        showAppoinmentData?.clinic?.productCategory?.product_category_id == 3 ? 'corporate' : 'd2c')
    );
    if (showAppoinmentData) {
      payload = {
        ...payload,
        appointment_type_int: 1,
      };
      // Always add preferred_gender and languages if they were selected
      if (showAppoinmentData.gender && showAppoinmentData.gender !== 'no_preference') {
        payload = {
          ...payload,
          preferred_gender: showAppoinmentData.gender,
        };
      }
      if (showAppoinmentData.language) {
        let lang = showAppoinmentData.language;
        if (
          showAppoinmentData.language &&
          showAppoinmentData.language.value
        ) {
          lang = showAppoinmentData.language.value;
        }
        if (lang) {
          payload = {
            ...payload,
            languages: [lang] ?? [1],
          };
        }
      }
    }
    if (values?.comment) {
      payload = {
        ...payload,
        notes: values?.comment,
      };
    }
    if (
      showAppoinmentData &&
      showAppoinmentData.slot &&
      showAppoinmentData.slot.info &&
      showAppoinmentData.slot.info.start_time
    ) {
      // v2 get-available-slots keys are already real ISO dates (YYYY-MM-DD);
      // date_select was a v1-only field that no longer exists on the slot object.
      const formatted = showAppoinmentData.slot.info?.date_select || showAppoinmentData.slot.date;
      let timeDiff = 15;
      if (
        showAppoinmentData &&
        showAppoinmentData.isUpdate &&
        showAppoinmentData.isUpdate &&
        showAppoinmentData?.data?.duration_id &&
        (_catTypePref2 === 'gp' || showAppoinmentData?.data?.product_category_id == 1)
      ) {
        timeDiff = location.state.durationObjectById[
          showAppoinmentData?.data?.duration_id
        ]
          ? location.state.durationObjectById[
            showAppoinmentData?.data?.duration_id
          ].duration
          : 15;
      } else {
        if (
          location.state &&
          location.state.durationObjectById &&
          showAppoinmentData.duration
        ) {
          timeDiff = location.state.durationObjectById[
            showAppoinmentData.duration
          ]
            ? location.state.durationObjectById[showAppoinmentData.duration]
              .duration
            : 15;
        }
      }
      let endtime = addMinutesToTime(
        showAppoinmentData.slot.info.start_time,
        timeDiff,
      );
      // Non-GP: end_time comes from slot
      if (_catTypePref2 !== 'gp') {
        endtime = showAppoinmentData?.slot?.info?.end_time ?? 15;
      }
      payload = {
        ...payload,
        start_time: `${formatted} ${showAppoinmentData.slot.info.start_time}`,
        end_time: `${formatted} ${endtime}`,
        product_category_id:
          showAppoinmentData?.clinic?.productCategory?.product_category_id ?? 1,
        override_spacers: 0,
      };
      // Non-GP: add product_id + product_category_id; GP: add duration_id
      if (_catTypePref2 !== 'gp') {
        payload = {
          ...payload,
          product_id:
            showAppoinmentData?.clinic?.non_gp_product_id ||
            showAppoinmentData?.non_gp_product_id,
          product_category_id:
            showAppoinmentData?.clinic?.productCategory?.product_category_id ?? null,
        };
      } else {
        payload = {
          ...payload,
          duration_id: showAppoinmentData?.duration,
        };
      }
    }
    if (
      showAppoinmentData.slot &&
      showAppoinmentData.slot?.info &&
      showAppoinmentData.slot?.info.price
    ) {
      payload = {
        ...payload,
        charges: showAppoinmentData.slot?.info.price,
        additional_charges: showAppoinmentData.slot?.info?.additional_charges,
      };
    }
    if (patient && Object.keys(patient).length) {
      payload = {
        ...payload,
        patient,
      };
    }
    if (
      showAppoinmentData &&
      showAppoinmentData.isUpdate &&
      showAppoinmentData.isUpdate &&
      showAppoinmentData.data &&
      showAppoinmentData.data
    ) {
      payload = {
        ...payload,
        // Use the user's updated preference if set, then fall back to the original.
        // Also handles 'female' which the old code missed (only checked 'male').
        preferred_gender: (
          showAppoinmentData.gender && showAppoinmentData.gender !== 'no_preference'
            ? showAppoinmentData.gender
            : (showAppoinmentData.data.preferred_gender || 'no_preference')
        ),
        // "clinic_id": showAppoinmentData.data.clinic_id,
        appointment_type_int: showAppoinmentData.data.appointment_type_int,
        duration_id: showAppoinmentData.data.duration_id ?? undefined,
        status: showAppoinmentData.data.status,
      };
      if (showAppoinmentData.data.duration_id) {
        payload = {
          ...payload,
          duration_id: showAppoinmentData.data.duration_id ?? undefined,
        };
      } else {
        payload = {
          ...payload,
          product_id:
            showAppoinmentData?.clinic?.non_gp_product_id ||
            showAppoinmentData?.data?.non_gp_product_id,
        };
      }
    }
    if (
      showAppoinmentData &&
      showAppoinmentData.clinic &&
      showAppoinmentData.clinic.isChargesOverRide
    ) {
      payload = {
        ...payload,
        override_spacers: 1,
        rescheduling_charge: 0,
      };
    } else {
      payload = {
        ...payload,
        override_spacers: 0,
        rescheduling_charge: showAppoinmentData?.data?.rescheduling_charge ?? 0,
      };
    }
    let url = "";
    if (
      showAppoinmentData &&
      showAppoinmentData.isUpdate &&
      showAppoinmentData.isUpdate &&
      showAppoinmentData?.data?.appointment_id
    ) {
      url = `${Config.url}appointments/${showAppoinmentData?.data?.appointment_id}`;
      try {
        const response = await axios.put(url, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        setholdAppointmentData({
          ...response.data.data,
          first_name: values.first_name,
          last_name: values.last_name,
          email: values.email,
          mobile_number: values.mobile_number,
        });
        if (response.data.success) {
          stopCountdown();
          gtaCustomEventPush({
            BookedAppointmentPayload: { data: response.data.data },
            paymentIntentResponseCatchPayload: response,
          });
          confirmBookinFunction({ ...payload }, "BookingConfirmation");
          pushTraceLogEvent({
            event: "booking_completed",
            payload: {
              step: "Book Succesfully",
              record_id: showAppoinmentData?.data?.appointment_id,
              is_last_step: true,
              patient_details_filled: true,
            },
            step_status: "success",
          });
        } else {
          messageApi.error({
            type: "succes",
            content: response.data.message || "Something Went wrong",
          });
          pushTraceLogEvent({
            event: "appointment_update_failed",
            payload: {
              step: "appointment_update_failed",
              payment_method: selected,
              patient_details: payload,
              is_last_step: true,
              patient_details_filled: true,
            },
            step_status: "failed",
          });
        }
        setformloading(false);
      } catch (error) {
        console.log("error :::", error);
        pushTraceLogEvent({
          event: "appointment_update_failed",
          payload: {
            step: "appointment_update_failed",
            payment_method: selected,
            patient_details: payload,
            is_last_step: true,
            patient_details_filled: true,
            reason: "exception",
            message: error?.response?.data?.message || error?.message,
          },
          step_status: "failed",
        });
        messageApi.error({
          type: "succes",
          content:
            error.response?.data?.message ||
            error.message ||
            "Something Went wrong",
        });
        setformloading(false);
      }
    } else {
      url = `${Config.url}appointments`;
      try {
        const response = await axios.post(url, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        setholdAppointmentData({
          ...response.data.data,
          first_name: values.first_name,
          last_name: values.last_name,
          email: values.email,
          mobile_number: values.mobile_number,
        });
        if (response.data.success) {
          stopCountdown();
          gtaCustomEventPush({
            BookedAppointmentPayload: { ...response.data.data },
            paymentIntentResponseCatchPayload: response,
          });
          pushTraceLogEvent({
            event: "booking_completed",
            payload: {
              step: "Book Succesfully",
              record_id: response?.data?.data?.appointment_id,
              is_last_step: true,
              patient_details_filled: true,
            },
            step_status: "success",
          });
          confirmBookinFunction({ ...payload }, "BookingConfirmation");
        } else {
          messageApi.error({
            type: "succes",
            content: response.data.message || "Something Went wrong",
          });
          pushTraceLogEvent({
            event: "appointment_book_failed",
            payload: {
              step: "appointment_book_failed",
              payment_method: selected,
              patient_details: payload,
              is_last_step: true,
              patient_details_filled: true,
            },
            step_status: "failed",
          });
        }
        setformloading(false);
      } catch (error) {
        console.log("error :::", error);
        pushTraceLogEvent({
          event: "appointment_book_failed",
          payload: {
            step: "appointment_book_failed",
            payment_method: selected,
            patient_details: payload,
            is_last_step: true,
            patient_details_filled: true,
            reason: "exception",
            message: error?.response?.data?.message || error?.message,
          },
          step_status: "failed",
        });
        messageApi.error({
          type: "succes",
          content:
            error.response?.data?.message ||
            error.message ||
            "Something Went wrong",
        });
        setformloading(false);
      }
    }
  };
  const getCardDetails = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const cardNumber = elements.getElement(CardNumberElement);
        const { error, paymentMethod } = await stripe.createPaymentMethod({
          type: "card",
          card: cardNumber,
          billing_details: { name: "Shiv kumar" },
        });
        if (error && error.message) {
          setStripeError(error.message);
          // Scroll to the card section so the user can see the inline error
          const cardSection = document.getElementById("stripe-card-section");
          if (cardSection) cardSection.scrollIntoView({ behavior: "smooth", block: "center" });
          resolve(false);
        }
        if (paymentMethod && paymentMethod.id) {
          resolve(true);
        }
      } catch (error) {
        messageApi.error({
          type: "error",
          content:
            error.response?.data?.message ||
            error.message ||
            "Something Went wrong",
        });
        resolve(false);
      }
    });
  };
  const createPayment = async (
    data,
    cardHolderName = null,
    isReschedule = false,
  ) => {
    // console.log('::data:', data)
    // console.log('::cardHolderName:', cardHolderName)
    return new Promise(async (resolve, reject) => {
      try {
        if (!data.appointment_id && !data.charges) {
          messageApi.error({
            type: "error",
            content: "Appointment ID or charges not found.",
          });
          resolve(false);
        }
        const cardNumber = elements.getElement(CardNumberElement);
        let payload = {
          type: "card",
          card: cardNumber,
        };
        let newCardHolderName = `${data?.first_name} ${data?.last_name}`;
        if (cardHolderName && isDifferentCardHolder) {
          payload = {
            ...payload,
            billing_details: {
              name: isDifferentCardHolder ? cardHolderName : "No Name",
              email: data.email,
              phone: data.mobile_number,
            },
          };
        } else {
          payload = {
            ...payload,
            billing_details: {
              name: newCardHolderName,
              email: data.email,
              phone: data.mobile_number,
            },
          };
        }
        const { error, paymentMethod } =
          await stripe.createPaymentMethod(payload);
        if (error && error.message) {
          setStripeError(error.message);
          // Scroll to the card section so the user can see the inline error
          const cardSection = document.getElementById("stripe-card-section");
          if (cardSection) cardSection.scrollIntoView({ behavior: "smooth", block: "center" });
          setformloading(false);
          pushTraceLogEvent({
            event: "card_payment_failed",
            payload: {
              step: "card tokenization failed",
              payment_method: "card",
              error_message: error.message,
              is_last_step: true,
              record_id: data?.appointment_id || null,
            },
            step_status: "failed",
          });
          resolve(false);
          return;
        }
        // Clear any previous card error on success
        setStripeError("");
        if (!paymentMethod?.id) {
          resolve(false);
          return;
        }
        // console.log('paymentMethod :::', paymentMethod)
        let clinicName =
          location?.state?.allClinicDataByID &&
            location?.state?.allClinicDataByID[data.clinic_id]
            ? location?.state?.allClinicDataByID[data.clinic_id].name
            : "No Found";
        // console.log('clinicName :::', clinicName)
        // For a new (non-reschedule) booking, `data.charges` now reflects the
        // appointment's ORIGINAL/list price (see onFinish) — the amount actually
        // charged via Stripe must independently use the discounted special price
        // (showAppoinmentData.slot.info.price, already normalised) when a special
        // pricing band applies, so a recorded "original price" never overcharges
        // the patient. Reschedule is unaffected — it charges rescheduling_charge,
        // not the slot price.
        const _cpHasSpecialBand = !isReschedule && !!showAppoinmentData?.slot?.info?.special_pricing_band;
        const _cpBaseAmount = _cpHasSpecialBand
          ? parseFloat(showAppoinmentData.slot.info.price) || 0
          : parseFloat(data.charges) || 0;
        const originalAmount = _cpBaseAmount;
        let createPaymentStripePayload = {
          session_id: session_id,
          appointment_id: data.appointment_id,
          amount: (isReschedule && showAppoinmentData.slot?.info?.additional_charges) ? parseFloat(data.charges) + parseFloat(showAppoinmentData.slot?.info.additional_charges) : (_cpBaseAmount - parseFloat(couponDiscount)) || 0,
          ...(promoCodeId && { discount_id: promoCodeId }),
          currency: "gbp",
          payment_method: paymentMethod.id,
          description: `${data.product_category_name ? data.product_category_name : ""
            } - ${clinicName}`,
        };
        console.log('createPaymentStripePayload :::', createPaymentStripePayload)
        if (isReschedule) {
          createPaymentStripePayload = {
            ...createPaymentStripePayload,
            type: "reschedule",
          };
        } else {
          createPaymentStripePayload = {
            ...createPaymentStripePayload,
            type: "appointment",
          };
        }
        const response = await axios.post(
          `${Config.url}create-payment-stripe`,
          createPaymentStripePayload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        // console.log('cardNumber :::', response)
        if (response.data && response.data.message == "requires_action") {
          const client_secret = response.data.data.client_secret;
          let rspo = await waitForTwoFactAuth(client_secret);
          if (rspo) {
            gtaCustomEventPush({
              BookedAppointmentPayload: { data },
              paymentIntentResponseCatchPayload: response,
            });
            stopCountdown()
            pushTraceLogEvent({
              event: "card_payment_successful",
              payload: {
                step: "card payment successful",
                payment_method: "card",
                is_last_step: true,
                record_id: data?.appointment_id || null,
                patient_details_filled: true,
                three_d_secure: true,
              },
              step_status: "success",
            });
            resolve(true);
          } else {
            // NOTE: previously this branch fell through to the same
            // "card_payment_successful" log below — 3D Secure failures were
            // being mis-recorded as successful payments. Fixed to log the
            // actual outcome and stop here instead of falling through.
            pushTraceLogEvent({
              event: "card_payment_failed",
              payload: {
                step: "3D Secure authentication failed",
                payment_method: "card",
                is_last_step: true,
                record_id: data?.appointment_id || null,
              },
              step_status: "failed",
            });
            resolve(false);
          }
        } else {
          gtaCustomEventPush({
            BookedAppointmentPayload: { data },
            paymentIntentResponseCatchPayload: response,
          });
          stopCountdown()
          pushTraceLogEvent({
            event: "card_payment_successful",
            payload: {
              step: "card payment successful",
              payment_method: "card",
              is_last_step: true,
              record_id: data?.appointment_id || null,
              patient_details_filled: true,
            },
            step_status: "success",
          });
          resolve(true);
        }
      } catch (error) {
        console.log("try catch error  in payment ", error);
        pushTraceLogEvent({
          event: "card_payment_failed",
          payload: {
            step: "card payment failed",
            payment_method: "card",
            error_message:
              error.response?.data?.message ||
              error?.message ||
              "Error occurred",
            is_last_step: true,
            record_id: data?.appointment_id || null,
          },
          step_status: "failed",
        });

        messageApi.error({
          type: "error",
          content:
            error.response?.data?.message ||
            error.message ||
            "Something Went wrong",
        });
        resolve(false);
      }
    });
  };
  const confirmBookinFunction = (data, type = null) => {
    // console.log('::::confirmBookinFunction:::', data, type)
    if (!data) {
      return;
    }
    // Clear countdown timer on successful booking confirmation
    if (type === "BookingConfirmation") {
      stopSession(); // IOO-275: use hook to cleanly stop all timer state
      setCurrentStep("");
    }
    setshowAppoinmentData((priviousData) => ({
      ...priviousData,
      confirm: {
        ...data,
        appliedDiscount: couponDiscount,
        appliedCouponCode: couponCode,
      },
    }));
    resetCouponState();
    resetPatientForm();
    if (type) {
      setshowAppoinmentDataDisplay(type);
    }
  };
  const waitForTwoFactAuth = async (clientSecret) => {
    return new Promise(async (resolve, reject) => {
      const { paymentIntent, error } =
        await stripe.confirmCardPayment(clientSecret);
      if (error) {
        console.error(error.message);
        pushTraceLogEvent({
          event: "three_d_secure_confirmation_failed",
          payload: { message: error.message },
          step_status: "failed",
        });
        resolve(false);
      } else if (paymentIntent && paymentIntent.status === "succeeded") {
        let aourApiRepo =
          await confirmAppointmentAfterTwoFactAuth(paymentIntent);
        if (aourApiRepo) {
          stopCountdown()
          resolve(true);
        } else {
          resolve(false);
        }
      }
    });
  };
  const confirmAppointmentAfterTwoFactAuth = (paymentIntent) => {
    // console.log('confirmAppointmentAfterTwoFactAuth :::', paymentIntent)
    let payload = {
      payment_intent_id: paymentIntent.id,
      ...(promoCodeId && { discount_id: promoCodeId }),
    };
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.post(
          `${Config.url}check-stripe-payment`,
          payload,
        );
        if (response.data && response.data.success) {
          pushTraceLogEvent({
            event: "check_stripe_payment_succeeded",
            payload: { payment_intent_id: paymentIntent.id },
            step_status: "success",
            response: response.data,
          });
          resolve(true);
        } else {
          pushTraceLogEvent({
            event: "check_stripe_payment_failed",
            payload: { payment_intent_id: paymentIntent.id },
            step_status: "failed",
            response: response.data,
          });
          resolve(false);
        }
      } catch (error) {
        pushTraceLogEvent({
          event: "check_stripe_payment_failed",
          payload: {
            payment_intent_id: paymentIntent.id,
            message: error?.response?.data?.message || error?.message,
          },
          step_status: "failed",
        });
        resolve(false);
        console.log(
          "try catch error  in confirmAppointmentAfterTwoFactAuth ",
          error,
        );
        messageApi.error({
          type: "error",
          content:
            error.response?.data?.message ||
            error.message ||
            "Something Went wrong",
        });
      }
    });
  };
  const gtaCustomEventPush = async (payload = {}) => {
    // console.log("gtaCustomEventPush payload:", showAppoinmentData);
    // return
    try {
      // helpers
      const toHex = (buffer) => {
        return Array.from(new Uint8Array(buffer))
          .map((b) => b.toString(16).padStart(2, "0"))
          .join("");
      };
      const hashSHA256 = async (value = "") => {
        try {
          const encoder = new TextEncoder();
          const data = encoder.encode((value || "").toLowerCase().trim());
          if (
            window.crypto &&
            window.crypto.subtle &&
            window.crypto.subtle.digest
          ) {
            const hashBuffer = await window.crypto.subtle.digest(
              "SHA-256",
              data,
            );
            return toHex(hashBuffer);
          }
        } catch (e) {
          // fallback simple (not recommended) : return unhashed (but keep lowercase)
          return (value || "").toLowerCase().trim();
        }
        return (value || "").toLowerCase().trim();
      };
      const formatPhone = (phone = "") => {
        if (!phone) return "";
        let digits = ("" + phone).replace(/\D/g, "");
        // if starts with 0 and 10-11 digits -> convert to +44
        if (digits.length >= 10 && digits[0] === "0") {
          digits = "44" + digits.slice(1);
        }
        if (!digits.startsWith("44") && digits.length === 10) {
          // assume UK local without leading zero
          digits = "44" + digits;
        }
        return "+" + digits;
      };
      const getCountryName = (val) => {
        if (!val) return "GB";
        // If user stored country code already, return it; otherwise try simple mapping
        if (val.length === 2) return val.toUpperCase();
        return val;
      };

      // get user data - prefer payload.userData, else try localStorage
      let userData = payload?.BookedAppointmentPayload?.data || payload?.BookedAppointmentPayload || null;
      if (!userData) {
        try {
          const raw = localStorage.getItem("userData");
          if (raw) userData = JSON.parse(raw);
        } catch (e) {
          userData = null;
        }
      }

      let user_data = null;

      if (userData) {
        const hashedEmail = await hashSHA256(userData?.email || "");
        const hashedPhone = await hashSHA256(
          formatPhone(userData?.mobile_number || ""),
        );
        const hashedFirstName = await hashSHA256(userData?.firstName || "");
        const hashedLastName = await hashSHA256(userData.lastName || "");
        const hashedCity = await hashSHA256(userData.city || "");
        const postal = await hashSHA256(userData.postal_code || "");
        const countryHashed = await hashSHA256(
          getCountryName(userData.country || userData.country_code || "GB"),
        );
        user_data = {
          email: hashedEmail,
          phone_number: hashedPhone,
          address: {
            first_name: hashedFirstName,
            last_name: hashedLastName,
            city: hashedCity,
            postal_code: postal,
            country: countryHashed,
          },
        };
        pushTraceLogEvent({
          event: "enhanced_conversion pushed",
          payload: {
            event: "enhanced_conversion",
            user_data: user_data,
          },
          step_status: "success",
        });
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "enhanced_conversion",
          user_data: user_data,
        });
      }

      // Purchase event
      // price extraction - prefer showAppoinmentData.price then payload
      // Determine productName based on product_category_id
      const clinicName =
        showAppoinmentData?.slot?.clinicData?.name ||
        payload?.showAppoinmentData?.slot?.clinicData?.name ||
        "Unknown Clinic";
      const product_category_id =
        showAppoinmentData?.clinic?.productCategory?.product_category_id;
      const product_variant = showAppoinmentData?.selectedProduct?.name || null;
      const corporate_name =
        showAppoinmentData?.clinic?.selectedCorporate?.name || null;
      const priceSource = userData?.charges || "";
      const priceString = ("" + priceSource).replace(/£\s+/g, "").trim();
      const price = parseFloat(priceString) || 0;
      const _analyticsCatType = (
        showAppoinmentData?.clinic?.productCategory?.type ||
        (product_category_id == 1 ? 'gp' : product_category_id == 3 ? 'corporate' : 'd2c')
      );
      let productName;
      let obj = {};
      if (_analyticsCatType === 'gp') {
        productName = "GP Appointments";
        obj = {
          item_name: clinicName,
          item_id: "GP Appointments",
          price: price,
          quantity: 1,
        };
      } else if (_analyticsCatType === 'corporate') {
        productName = "Corporates Appointments";
        obj = {
          item_name: clinicName,
          item_id: "Corporates Appointments",
          item_category: corporate_name,
          item_variant: product_variant,
          price: price,
          quantity: 1,
        };
      } else {
        // d2c, health, dental, women health, blood test — any expandable non-GP/non-corporate
        productName =
          showAppoinmentData?.clinic?.productCategory?.title ||
          showAppoinmentData?.clinic?.productCategory?.name ||
          "Health screens";
        obj = {
          item_name: clinicName,
          item_id: product_variant,
          price: price,
          quantity: 1,
        };
      }

      // const productName = showAppoinmentData?.clinic?.productCategory?.title || (showAppoinmentData?.clinic?.productCategory?.name) || '';
      const appointmentId =
        payload?.BookedAppointmentPayload?.data?.appointment_id ||
        payload?.BookedAppointmentPayload?.appointment_id ||
        (holdAppointmentData && holdAppointmentData.appointment_id) ||
        "unknown";
      const trasnaction_id =
        payload?.paymentIntentResponseCatchPayload?.data?.data?.latest_charge ||
        payload?.BookedAppointmentPayload?.data?.gtm_txn_id ||
        payload?.BookedAppointmentPayload?.gtm_txn_id ||
        "unknown";
      // console.log("gtaCustomEventPush :::", trasnaction_id, obj);
      if (trasnaction_id) {
        const traceLogPayload = {
          ecommerce: {
            currency: "GBP",
            value: price,
            transaction_id: trasnaction_id,
            items: [{ ...obj }],
          },
        };
        if (user_data) {
          traceLogPayload.user_data = user_data;
        }
        pushTraceLogEvent({
          event: "purchase event pushed",
          payload: traceLogPayload,
          step_status: "success",
        });
        window.dataLayer = window.dataLayer || [];
        const purchasePayload = {
          event: "purchase",
          ecommerce: {
            currency: "GBP",
            value: price,
            transaction_id: trasnaction_id,
            items: [{ ...obj }],
          },
        };
        if (user_data) {
          purchasePayload.user_data = user_data;
        }
        window.dataLayer.push(purchasePayload);
        // window.sessionStorage.setItem(trasnaction_id, 'sent');
      }
    } catch (err) {
      // swallow errors - do not block main flow
      // eslint-disable-next-line no-console
    }
  };
  const addMinutesToTime = (timeStr, minutesToAdd = 15) => {
    return moment(timeStr, "HH:mm")
      .add(minutesToAdd, "minutes")
      .format("HH:mm");
  };
  const hideConfirm = () => {
    setshowAppoinmentDataDisplay(null);
    resetCouponState();
    resetPatientForm();
    setcalenderData({});
    getAllDataBYApi(clinicSelected.id, selectedDate);
  };
  const callBackForbackpage = (type) => {
    // Only clear booking session if there is no active blocked slot.
    // If bookingSessionId exists, the user holds a blocked slot — preserve it
    // so slot_session_id stays available for preferred-clinics / available-slots.
    // Session is cleared only when the user is abandoning from a fresh (unblocked) state.
    const hasActiveSession = !!localStorage.getItem("bookingSessionId");
    if (!hasActiveSession) {
      stopCountdown();
      // localStorage.removeItem("bookingSessionId");
      localStorage.removeItem("bookingExpiresAt");
      // trace_log_id is NOT cleared here — it's a whole-journey analytics
      // session, not tied to the slot-hold session, and isn't regenerated
      // once cleared (only seeded once when the journey opens), so wiping it
      // on a step "Back" click would leave session_id null on submission.
    }

    // IOO-198: When going back from slot selection during a reschedule,
    // route to ReschedulePreferenceStep (not BookingForm) so readOnlyDuration
    // stays true and "Book at preferred clinic" remains hidden.
    const isReschedule = showAppoinmentData?.clinic?.isReshedula;
    const resolvedType = (type === "BookingForm" && isReschedule)
      ? "ReschedulePreferenceStep"
      : type;

    setshowAppoinmentDataDisplay(resolvedType);
  };


  // console.log('calenderData.patient::::', calenderData?.patient)
  const getDataFrom = (data) => {
    // Clear any active booking session when initiating a new Create action.
    // trace_log_id is NOT cleared here — see createAppointment's comment above.
    stopCountdown();
    localStorage.removeItem("bookingSessionId");
    localStorage.removeItem("bookingExpiresAt");

    if (data === "APPOINMENT") {
      setOpen(false);
    }
    // console.log('data:getDataFrom::', data)
    if (data == "LUNCH" || data == "SPACER" || data == "BLOCK") {
      setappointmentType(true);
      setspacerAndLunch(null);
    } else {
      console.trace("[scroll-debug] getDataFrom scrolling to .createAppointment, data=", data);
      setTimeout(() => {
        document
          .querySelector(".createAppointment")
          ?.scrollIntoView({ behavior: "smooth" });
      }, 100);
      setappointmentType(false);
    }
    setshowAppoinmentDataDisplay(data);
    resetPatientBookingFields();
    setcalenderData({});
    resetCouponState();
    resetPatientForm();
  };
  const gotoTodayDate = () => {
    if (isTypeWeek) {
      onSelect(moment(), null, "Week");
    }
    if (moment().format("YYYY-MM-DD") != selectedDate) {
      setloaderTimeAndDate(true);
      setSelectedDate(moment().format("YYYY-MM-DD"));
      setTimeout(() => {
        setloaderTimeAndDate(false);
      }, 1);

      // setisTypeWeek(false)
      // setWeekRange([]);
    }
  };
  const syncAppointment = async () => {
    setsyncloader(true);

    try {
      // ─── STEP 1: Check if a cron is already running ───────────────────────
      const statusRes = await axios.get(`${Config.url}webjob/status`, {
        params: { cron_name: "semble-cron" },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      const latestRun = statusRes?.data?.data?.latest_run;
      const rawStatus = latestRun?.status ?? null;
      const currentStatus = rawStatus ? rawStatus.toLowerCase() : null;
      const currentRunId = latestRun?.id ? String(latestRun.id) : null;

      if (currentStatus === "running" && currentRunId) {
        // ─── STEP 2a: Already running — attach to existing cron ───────────
        // Do NOT fire a new POST. Track the existing run ID.
        localStorage.setItem(SEMBLE_CRON_LS_KEY, currentRunId);
        setCronStatus("running");
        setsyncloader(false);
        startCronPolling(currentRunId);
        messageApi.info("A Semble sync is already in progress. Tracking existing job...");
      } else {
        // ─── STEP 2b: Not running — start a new cron job ──────────────────
        const runRes = await axios.post(
          `${Config.url}webjob/run`,
          { cron_name: "semble-cron" },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        if (runRes?.data?.success) {
          // Get the new cron run ID from the POST response, or fall back to a
          // fresh GET webjob/status call if the response doesn't include an ID.
          let newRunId = runRes?.data?.data?.id
            ? String(runRes.data.data.id)
            : null;

          if (!newRunId) {
            // Fallback: fetch status immediately to get latest_run.id
            try {
              const fallbackRes = await axios.get(`${Config.url}webjob/status`, {
                params: { cron_name: "semble-cron" },
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
              });
              newRunId = fallbackRes?.data?.data?.latest_run?.id
                ? String(fallbackRes.data.data.latest_run.id)
                : null;
            } catch (_) {
              // If fallback fails, continue without an ID — polling won't start
            }
          }

          if (newRunId) {
            localStorage.setItem(SEMBLE_CRON_LS_KEY, newRunId);
            setCronStatus("running");
            setsyncloader(false);
            startCronPolling(newRunId);
            messageApi.success(
              runRes.data.message || "Semble sync started successfully."
            );
          } else {
            // Started but couldn't get an ID — reset and inform user
            setsyncloader(false);
            messageApi.success(
              runRes.data.message || "Semble sync started. Refresh shortly to check status."
            );
          }
        } else {
          setsyncloader(false);
          messageApi.error(
            runRes?.data?.message || "Failed to start appointment sync."
          );
        }
      }
    } catch (error) {
      setsyncloader(false);
      console.log("syncAppointment error :::", error);
      messageApi.error(
        error.response?.data?.message ||
        error.message ||
        "Something went wrong while starting appointment sync."
      );
    }
  }
  const handleRestrictedCardClick = (category) => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    // const role = userData?.roles[0]?.role_id;
    const role = userData?.roles?.[0]?.role_id;
    //             CSR and CSR-R: Only access dashboard and profile
    // CSR can't click on Pending refund and Missing gender lights
    // CSR-R: only can't click on Missing gender lights
    // console.log("categorycategorycategory", category.label_name)

    const restrictedForCSR = [
      "pending_refunds_alert",
      "clinician_gender_missing_alert",
    ];

    const restrictedForCSRR = ["clinician_gender_missing_alert"];

    if (
      (role === 2 && restrictedForCSR.includes(category.id)) ||
      (role === 3 && restrictedForCSRR.includes(category.id))
    ) {
      messageApi.info(
        `You don't have permission to view details of ${category?.label_name || "this"
        } alert.`,
      );
      return;
    }

    handleCardClick(category); // ✅ Allow click otherwise
  };

  const handleCardClick = (category) => {
    // console.log("category",category)
    if (category && category.availability) {
      if (category.id == "pending_refunds_alert") {
        // console.log('In If::::::pending-refunds', category)
        navigate("/pending-refunds", {
          state: {
            category,
            clinic_id: clinicSelected.id,
            date: selectedDate,
            end_date: selectedDate,
          },
        });
      }
      if (category.id == "clinician_gender_missing_alert") {
        navigate("/clinician-profile", {
          state: {
            category,
            clinic_id: clinicSelected.id,
            allClinicData,
            state: location.state,
          },
        });
      }
      if (
        category.id == "spacers_overwritten_alert" ||
        category.id == "clinician_availability_conflict_alert"
      ) {
        navigate("/signal-details", {
          state: {
            category,
            allClinicData,
            state: location.state,
            clinic_id: clinicSelected.id,
          },
        });
      }
    }
    if (category && category?.data && category.id == "preference_conflict_alert") {
      navigate("/signal-details", {
        state: {
          category,
          allClinicData,
          state: location.state,
          clinic_id: clinicSelected.id,
        },
      });
    }
  };
  const checkisDiffrentCardHolder = (data) => {
    if (data.target.checked) {
      setisDifferentCardHolder(true);
    } else {
      setisDifferentCardHolder(false);
    }
  };
  const loadMoredata = () => {
    let payload = {
      search_value: debouncedInputValueData,
    };
    if (searchData && searchData.pagination && searchData.pagination.has_more) {
      payload = {
        ...payload,
        offset: searchData.pagination.offset + 10,
      };
    }
    if (payload && payload.offset) {
      getAllCsrDataByApi(payload);
    }
  };
  const dropdownMenu = (
    <Menu style={{ maxHeight: 360, width: "100%", position: "relative" }}>
      {filteredData.length > 0 ? (
        filteredData.map((item) => {
          const label = `${item.patient.first_name} ${item.patient.last_name} | ${item.patient.mobile_number}`;
          return (
            <Menu.Item
              key={item.appointment_id}
              onClick={() => handleSelect(item)}
            >
              {label}
            </Menu.Item>
          );
        })
      ) : (
        <Menu.Item disabled>No results found</Menu.Item>
      )}
      {searchData.pagination && searchData.pagination.has_more && (
        <>
          <Divider style={{ margin: "4px 0" }} />
          <Menu.Item key="load-more" disabled>
            <Button
              size="small"
              loading={searchLoading}
              block
              onClick={loadMoredata}
            >
              Load More
            </Button>
          </Menu.Item>
        </>
      )}
    </Menu>
  );
  const handleSelect = (item) => {
    let clinic_id = item.clinic_id; // or any valid clinic ID you're looking for
    let data = allClinicData.find((item) => item.id == clinic_id);
    if (data) {
      getAllDataBYApi(item.clinic_id, item.appointment_date);
      setclinicSelected(data);
      setSelectedDate(item.appointment_date);
      setsearchData([]);
      setsearchPatientInput(null);
      navigate(location.pathname, {
        replace: true,
        state: {
          ...location.state,
          clinic: data,
        },
      });
    }
  };
  // Function to apply coupon
  const applyCoupon = async () => {
    if (!couponCode.trim()) {
      messageApi.error("Please enter a coupon code");
      return;
    }

    setApplyingCoupon(true);
    pushTraceLogEvent({
      event: "coupon_validation_initiated",
      payload: {
        coupon_code: couponCode.trim(),
        amount: showAppoinmentData?.data?.rescheduling_charge || showAppoinmentData.slot?.info.price,
      },
      step_status: "success",
    });
    try {
      const response = await axios.post(
        `${Config.url}coupon/validate`,
        {
          code: couponCode.trim(),
          session_id: session_id,
          amount: showAppoinmentData?.data?.rescheduling_charge || showAppoinmentData.slot?.info.price,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      // console.log("Coupon validation response:", response);

      // Check if coupon is valid
      if (!response.data?.data?.valid) {
        const apiErrorMessage = response.data?.data?.message || response.data?.message || "Invalid coupon";
        throw new Error(apiErrorMessage);
      }
      // Extract discount amount from response (in pence, so divide by 100 for pounds)
      const discountInPence = response.data?.data?.discount || 0;
      const discountInPounds = discountInPence / 100;
      const couponName = response.data?.data?.coupon?.name || couponCode;
      const percentOff = response.data?.data?.coupon?.percent_off || 0;
      const promoId = response.data?.data?.discount_id || null;

      setCouponDiscount(discountInPounds);
      setPromoCodeId(promoId);
      setCouponApplied(true);
      messageApi.success(response.data?.data?.message || "Coupon applied successfully");
      // addLog(`Coupon ${couponCode} (${couponName}) applied with discount £${discountInPounds} (${percentOff}% off)`, "success");
      pushTraceLogEvent({
        event: "coupon_validation_success",
        payload: {
          coupon_code: couponCode,
          coupon_name: couponName,
          discount_pounds: discountInPounds,
          percent_off: percentOff,
          promo_code_id: promoId,
          original_amount: showAppoinmentData?.data?.rescheduling_charge || showAppoinmentData.slot?.info.price,
        },
        step_status: "success",
      });
    } catch (error) {
      console.error("Failed to apply coupon:", error);
      const errorMessage = error.response?.data?.message || error.response?.data?.data?.message || error.message || "Failed to apply coupon";
      messageApi.error(errorMessage);
      // addLog(`Coupon application failed: ${errorMessage}`, "error");
      pushTraceLogEvent({
        event: "coupon_validation_failed",
        payload: {
          coupon_code: couponCode,
          error_message: errorMessage,
          error_type: error.response?.data?.data?.message ? "api_error" : "network_error",
          original_amount: showAppoinmentData?.data?.rescheduling_charge || showAppoinmentData.slot?.info.price,
        },
        step_status: "failed",
      });
      setCouponDiscount(0);
      setPromoCodeId(null);
      setCouponApplied(false);
    } finally {
      setApplyingCoupon(false);
    }
  };

  const pre_payment_enabled = (
    showAppoinmentData?.clinic?.productCategory?.type === 'corporate' ||
    showAppoinmentData?.clinic?.productCategory?.product_category_id == 3
  )
    ? showAppoinmentData?.selectedProduct?.pre_payment_enabled
    : true;
  const getChargesAmount = () => {
    if (showAppoinmentData?.isUpdate && showAppoinmentData?.data?.appointment_id) {
      return (showAppoinmentData?.clinic?.isChargesOverRide || showAppoinmentData?.clinic?.isAdditionalChargesOverridden) ? 0 : (showAppoinmentData?.data?.rescheduling_charge || 0);
    }
    return showAppoinmentData?.slot?.info?.price || 0;
  };
  const appointmentCharges = parseFloat(getChargesAmount()) || 0;
  const hasFullCouponDiscount = couponApplied && couponDiscount >= appointmentCharges && appointmentCharges > 0;
  // Whether the card-payment column will actually render. When it won't (full
  // coupon discount, OR a reschedule with charges/additional-charges fully
  // overridden to zero), no Stripe form is present to collect a billing
  // address, so Patientdetails must collect country/postal code itself.
  // Wrapped in !! so this is always a real boolean — additional_charges can
  // legitimately be the number 0, and `0 && (<Col/>)` renders the text "0"
  // instead of nothing (this was the exact bug: a bare "0" appearing on
  // screen whenever a reschedule had additional_charges === 0).
  const showPaymentColumn = !!(
    !hasFullCouponDiscount &&
    ((!showAppoinmentData?.clinic?.isChargesOverRide && !showAppoinmentData?.clinic?.isAdditionalChargesOverridden) ||
      showAppoinmentData?.slot?.info?.additional_charges) &&
    pre_payment_enabled
  );
  const userTempData = localStorage.getItem("userData");
  const userData = userTempData ? JSON.parse(userTempData) : {};
  const role_id = userData?.roles?.[0]?.role_id;
  // console.log("role_id", role_id);
  // console.log("pre_payment_enabled",pre_payment_enabled,showAppoinmentData?.selectedProduct?.pre_payment_enabled)
  // console.log("calenderData",calenderData);

  // This page expects to be reached via navigation that sets location.state.clinic
  // (e.g. clicking a clinic from the dashboard). A direct URL visit or a hard
  // refresh has no such state, leaving clinicSelected undefined — every data-fetch
  // effect/handler below reads clinicSelected.id, which would otherwise throw an
  // uncaught TypeError. Redirect to the dashboard instead of crashing. Declared as
  // a render-time redirect (not a useEffect) so it takes effect on the very first
  // render, before any of the data-fetch effects below get a chance to run.
  if (!clinicSelected?.id) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <App>
      {contextHolder}
      {/* {stripePromise ? (
                <Elements stripe={stripePromise}> */}
      {role_id == '1' ? (
        <Row style={{ display: 'flex', justifyContent: "flex-end" }}>
          <Button
            loading={syncloader || cronStatus === "running"}
            disabled={syncloader || cronStatus === "running"}
            className="teal-primary-btn"
            style={{
              marginBottom: 10,
              backgroundColor: '#008385',
              borderColor: '#008385',
              color: '#fff',
              opacity: (syncloader || cronStatus === "running") ? 0.6 : 1,
              cursor: (syncloader || cronStatus === "running") ? 'not-allowed' : 'pointer',
            }}
            type="primary"
            onClick={syncAppointment}
          >
            {cronStatus === "running" ? "Syncing..." : "Sync Semble Appointments"}
          </Button>
          <Button
            className="teal-primary-btn"
            style={{ marginBottom: 10, marginLeft: 10, backgroundColor: '#008385', borderColor: '#008385' }}
            type="primary"
            onClick={() => navigate('/bank-holidays')}
          >
            Bank Holidays
          </Button>
        </Row>) : ''}

      {/* Real-time Semble sync banner — visible to ALL users when cron is running */}
      {cronStatus === "running" && (
        <Alert
          type="info"
          showIcon
          icon={<SyncOutlined spin />}
          message="Semble appointment sync is currently in progress. Calendar data will refresh automatically when complete."
          style={{ marginBottom: 10 }}
        />
      )}

      <Row
        justify="space-between"
        align="middle"
        style={{ marginBottom: "20px" }}
      >
        <CreateDropdown onSelect={getDataFrom} />
        <Button
          className="add-generic-btn"
          style={{ width: 92, height: 30 }}
          type="primary"
          onClick={gotoTodayDate}
        >
          Today
        </Button>
        <Select
          showSearch
          className="inputbox-custom-placeholder"
          // defaultValue={location.state?.clinic && location.state?.clinic.name ? location.state?.clinic.name : "Kings Cross"}
          value={
            location.state?.clinic && location.state?.clinic.name
              ? location.state?.clinic.name
              : "Kings Cross"
          }
          style={{ width: 300, marginLeft: 5 }}
          onChange={handleClinicSelect}
          optionFilterProp="children"
          filterOption={(input, option) => {
            return option.children.toLowerCase().includes(input.toLowerCase());
          }}
        >
          {location.state?.allClinicData?.data &&
            location.state?.allClinicData?.data.length &&
            location.state?.allClinicData?.data.map((clinic) => {
              return clinic.status != 0 ? (
                <Option value={clinic.id} key={clinic.id}>
                  {clinic?.name}
                </Option>
              ) : (
                ""
              );
            })}
        </Select>
        <span
          style={{
            fontSize: "16px",
            fontWeight: "500",
            color: "rgba(74, 74, 74, 1)",
          }}
        >
          {moment(selectedDate).format("dddd, D MMMM, YYYY")}
        </span>
        <Dropdown
          overlay={dropdownMenu}
          visible={!!searchPatientInput && filteredData.length > 0}
        >
          <Input.Search
            placeholder="Search patients by name, phone"
            value={searchPatientInput}
            allowClear
            onChange={(e) => setsearchPatientInput(e.target.value)}
            style={{ width: 250 }}
          />
        </Dropdown>
        <Select
          className="inputbox-custom-placeholder"
          defaultValue="Day"
          style={{ width: 79, height: 30 }}
          onSelect={(value) => {
            if (value == "Week") {
              // console.log('value', value ,"moment",moment(),"selectedDate",selectedDate,"selectedDate memo",moment(selectedDate, "YYYY-MM-DD"))
              setisTypeWeek(true);
              onSelect(moment(selectedDate, "YYYY-MM-DD"), null, value);
              // setSelectedDate(moment().format("YYYY-MM-DD"))
            } else {
              // console.log('value', value ,"moment",moment(),"selectedDate",selectedDate,"selectedDate memo",moment(selectedDate, "YYYY-MM-DD"))
              setisTypeWeek(false);
              setWeekRange([]);
              onSelect(moment(selectedDate, "YYYY-MM-DD"), null, null, "day");
              const dateMemo = moment(selectedDate, "YYYY-MM-DD");
              // setSelectedDate(moment().format("YYYY-MM-DD"))
            }
          }}
        >
          <Option value="Day">Day</Option>
          <Option value="Week">Week</Option>
        </Select>
      </Row>

      <Row gutter={[16, 16]}>
        <ConfigProvider locale={enGB}>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 6 }}
            lg={{ span: 6 }}
            xl={{ span: 6 }}
            xxl={{ span: 6 }}
          >
            <div style={wrapperStyle}>
              {isTypeWeek
                ? loaderTimeAndDate == false && (
                  <Calendar
                    fullscreen={false}
                    onChange={onPanelDateChange}
                    onSelect={onSelect}
                    cellRender={(current, info) => info.type === 'date' ? dateCellRender(current) : info.originNode}
                    headerRender={({ value, onChange }) => {
                      const current = value.clone();

                      const goToPreviousMonth = () => {
                        const newDate = current.subtract(1, "month");
                        onChange(newDate);
                      };

                      const goToNextMonth = () => {
                        const newDate = current.add(1, "month");
                        onChange(newDate);
                      };

                      return (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "10px 8px 12px 8px",
                          }}
                        >
                          <LeftOutlined
                            onClick={goToPreviousMonth}
                            style={{
                              cursor: "pointer",
                              fontSize: 16,
                              color: "#000",
                            }}
                          />
                          <span style={{ fontSize: 16, fontWeight: 500 }}>
                            {current.format("MMMM YYYY")}
                          </span>
                          <RightOutlined
                            onClick={goToNextMonth}
                            style={{ cursor: "pointer", fontSize: 16 }}
                          />
                        </div>
                      );
                    }}
                  // disabledDate={(current) => current && current.isBefore(moment().startOf("day"))}
                  />
                )
                : loaderTimeAndDate == false && (
                  <Calendar
                    fullscreen={false}
                    onChange={onPanelDateChange}
                    onSelect={onSelect}
                    // value={selectedDate}
                    cellRender={(current, info) => info.type === 'date' ? dateCellRender(current) : info.originNode}
                    headerRender={({ value, onChange }) => {
                      const current = value.clone();

                      const goToPreviousMonth = () => {
                        const newDate = current.subtract(1, "month");
                        onChange(newDate);
                      };

                      const goToNextMonth = () => {
                        const newDate = current.add(1, "month");
                        onChange(newDate);
                      };

                      return (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "10px 8px 12px 8px",
                          }}
                        >
                          <LeftOutlined
                            onClick={goToPreviousMonth}
                            style={{
                              cursor: "pointer",
                              fontSize: 16,
                              color: "#000",
                            }}
                          />
                          <span style={{ fontSize: 16, fontWeight: 500 }}>
                            {current.format("MMMM YYYY")}
                          </span>
                          <RightOutlined
                            onClick={goToNextMonth}
                            style={{
                              cursor: "pointer",
                              fontSize: 16,
                              color: "#000",
                            }}
                          />
                        </div>
                      );
                    }}
                  />
                )}
              <div style={{ marginTop: 20 }}>
                {/* {console.log("conflictAlertsData__", conflictAlertsData)} */}

                {conflictAlertsData &&
                  conflictAlertsData.length &&
                  conflictAlertsData.map((category, index) => (
                    <span key={category.id}>
                      {/* <Card hoverable onClick={() => handleCardClick(category)} className='step2-card'> */}
                      <Card
                        hoverable
                        onClick={() => handleRestrictedCardClick(category)}
                        className="step2-card"
                      >
                        <div className="step2-img">
                          <div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <Step
                                icon={
                                  <div
                                    style={{
                                      ...stepCss,
                                      background: category.availability
                                        ? "#008385"
                                        : "transparent",
                                    }}
                                  />
                                }
                              />
                            </div>
                          </div>
                          <div className="step2-card-headings">
                            {category.label_name}
                          </div>
                        </div>
                      </Card>
                    </span>
                  ))}
              </div>
            </div>
          </Col>
        </ConfigProvider>

        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 18 }}
          lg={{ span: 18 }}
          xl={{ span: 18 }}
          xxl={{ span: 18 }}
          style={{ width: "100%" }}
        >
          {appointmentData &&
            weekRange &&
            loaderCalender == false &&
            weekRange.length &&
            selectedDate
            ? loaderCalender == false && (
              <CalendarFull
                data={{ appointmentData }}
                clinic={clinicSelected}
                passDate={selectedDate}
                openModal={openModal}
              />
            )
            : loaderCalender == false && (
              <>
                <CalendarOneDay
                  data={{ appointmentData }}
                  clinic={clinicSelected}
                  passDate={selectedDate}
                  openModal={openModal}
                  createNewAppointment={createNewAppointment}
                  onRoomHeaderClick={handleRoomHeaderClick}
                />
                {/* IOO-307: Room Swap Modal */}
                <RoomSwapModal
                  visible={roomSwapModalVisible}
                  onClose={() => setRoomSwapModalVisible(false)}
                  onSwapSuccess={handleSwapSuccess}
                  sourceRoom={swapSourceRoom}
                  allRooms={appointmentData || []}
                  clinicId={clinicSelected?.id}
                  selectedDate={selectedDate}
                />
              </>
            )}
          {loaderCalender ? (
            <div style={{ marginTop: "15%" }}>
              <Spin className="custom-spinner" />{" "}
            </div>
          ) : (
            ""
          )}
        </Col>

        <div style={{ position: "absolute", top: 500, right: 30 }}>
          <Popover
            content={
              <Customappointmentmodal
                getAllHealthScreenData={{
                  getAllHealthScreenData,
                  allGPproduct,
                  location: location.state,
                }}
                appointmentData={appointmentData}
                appointmentDataActual={appointmentDataActual}
                closeModal={handleClose}
              />
            }
            overlayClassName="my-clean-popover"
            open={open}
            onOpenChange={handleOpenChange}
          ></Popover>
        </div>
      </Row>
      <div
        className="createAppointment"
        style={{ background: "#fff", marginTop: "50px" }}
      >
        {showAppoinmentDataDisplay == "APPOINMENT" && (
          <Appointmenttype
            getAllHealthScreenData={{ getAllHealthScreenData, allGPproduct }}
            callback={callbackAppointment}
            callBackForbackpage={callBackForbackpage}
          />
        )}
        {showAppoinmentData && showAppoinmentDataDisplay == "BookingForm" && (
          <BookingForm
            getAllHealthScreenData={{ getAllHealthScreenData, allGPproduct }}
            showAppoinmentData={showAppoinmentData}
            data={location.state}
            callbackBookingForm={callbackBookingForm}
            callBackForbackpage={callBackForbackpage}
          />
        )}
        {/* IOO-198: PREFERENCE STEP — shown before slot selection during reschedule.
            Reuses BookingForm with pre-populated original preferences.
            - GP: duration locked (read-only), language + gender editable
            - Non-GP: no duration, language shown if allow_language_selection,
                      gender shown if allow_gender_selection */}
        {showAppoinmentData && showAppoinmentDataDisplay === "ReschedulePreferenceStep" && (() => {
          const apptData = showAppoinmentData?.clinic?.calenderData;
          const catId = Number(showAppoinmentData?.clinic?.productCategory?.product_category_id);
          const isGP = catId === 1;
          const langData = location.state?.languageData || [];

          // Resolve initial language: prefer language_id from calenderData,
          // fall back to matching by language_name, default to '1' (English)
          const initLang = (() => {
            const raw = apptData?.language_id ?? apptData?.language;
            // Guard: only use raw if it's a real non-null, non-empty value
            if (raw !== null && raw !== undefined && raw !== '' && raw !== 'null') return String(raw);
            const matched = langData.find((l) =>
              l.label?.toLowerCase() === (apptData?.language_name || '').toLowerCase()
            );
            return matched ? String(matched.value) : '1';
          })();

          // Guard: ensure gender is one of the known valid values
          const rawGender = apptData?.preferred_gender;
          const initGender = (rawGender === 'male' || rawGender === 'female' || rawGender === 'no_preference')
            ? rawGender
            : 'no_preference';

          const initDuration = String(apptData?.duration_id ?? showAppoinmentData?.duration ?? '1');

          // Build prefFormData — BookingForm reads showAppoinmentData for initial state
          const prefFormData = {
            ...showAppoinmentData,
            duration: initDuration,
            gender: initGender,
            language: initLang,
          };

          return (
            <BookingForm
              key={apptData?.appointment_id || 'reschedule-prefs'}
              showAppoinmentData={prefFormData}
              getAllHealthScreenData={{ getAllHealthScreenData, allGPproduct }}
              data={location.state}
              callbackBookingForm={callbackRescheduleBookingForm}
              callBackForbackpage={() => setshowAppoinmentDataDisplay('APPOINMENT')}
              readOnlyDuration={true}
            />
          );
        })()}
        {showAppoinmentData &&
          showAppoinmentDataDisplay == "PreferredTimeclinic" && (
            <ClinicBooking
              setshowAppoinmentData={setshowAppoinmentData}
              getAllHealthScreenData={{ getAllHealthScreenData, allGPproduct }}
              showAppoinmentData={showAppoinmentData}
              data={location.state}
              callback={callbackClinicBooking}
              callBackForbackpage={callBackForbackpage}
              locSearchLog={locSearchLog}
              setlocSearchLog={setlocSearchLog}
              bookingSessionId={bookingSessionId}
            />
          )}
        {showAppoinmentData && showAppoinmentDataDisplay == "PreferredTime" && (
          <PreferredTime
            getAllHealthScreenData={{ getAllHealthScreenData, allGPproduct }}
            showAppoinmentData={showAppoinmentData}
            data={location.state}
            callback={callbackPreferredTime}
            callBackForbackpage={callBackForbackpage}
          />
        )}
        {/* The old standalone "confirm your booking" screen (BookingDetailsNext
            rendered full-screen for showAppoinmentDataDisplay=="AppointmentSelection")
            has been removed — callbackClinicBooking/callbackPreferredTime now skip
            straight from slot selection to the patient-details step below for every
            booking/reschedule scenario and category type. BookingDetailsNext is still
            rendered further down as a read-only (hide=true) summary alongside the
            patient-details form. */}
        {showAppoinmentData &&
          showAppoinmentDataDisplay == "BookingDetailsNext" && (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Form
                // autoComplete="off"
                layout="vertical"
                form={form}
                name="patient_details"
                onFinish={onFinish}
                onFinishFailed={handleSubmitFailed}
                scrollToFirstError={{ behavior: "smooth", block: "center" }}
                onValuesChange={(changedValues, allValues) => { }}
                initialValues={
                  calenderData.patient
                    ? {
                      ...calenderData.patient,
                      postalCode:
                        calenderData.patient.postal_code ||
                        calenderData.patient.postalCode ||
                        calenderData.postal_code ||
                        calenderData.postalCode ||
                        showAppoinmentData?.data?.postal_code ||
                        showAppoinmentData?.data?.postalCode ||
                        "",
                      postalCode1:
                        calenderData.patient.postal_code ||
                        calenderData.patient.postalCode ||
                        calenderData.postal_code ||
                        calenderData.postalCode ||
                        showAppoinmentData?.data?.postal_code ||
                        showAppoinmentData?.data?.postalCode ||
                        "",
                      date_of_birth: moment(
                        calenderData.patient.date_of_birth,
                        "YYYY-MM-DD",
                      ),
                      country_code:
                        calenderData.patient.country_code || "+44", // Default value
                    }
                    : null
                } //, gender: '', appointment_reason: ''
              >
                <BookingDetailsNext
                  getAllHealthScreenData={{
                    getAllHealthScreenData,
                    allGPproduct,
                  }}
                  showAppoinmentData={showAppoinmentData}
                  data={location.state}
                  callback={callbackBookingDetailsNext}
                  callBackForbackpage={callBackForbackpage}
                  hide={true}
                />
                <Row gutter={[16, 16]}>
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: hasFullCouponDiscount ? 24 : 12 }}
                    lg={{ span: hasFullCouponDiscount ? 24 : 12 }}
                    xl={{ span: hasFullCouponDiscount ? 24 : 12 }}
                    xxl={{ span: hasFullCouponDiscount ? 24 : 12 }}
                    style={hasFullCouponDiscount ? { display: "flex", justifyContent: "center" } : {}}
                  >
                    <Form.Item name="country_code" noStyle hidden>
                      <Input type="hidden" />
                    </Form.Item>
                    <Patientdetails
                      key={patientFormKey}
                      getAllHealthScreenData={{
                        getAllHealthScreenData,
                        allGPproduct,
                        showAppoinmentData,
                      }}
                      form={form}
                      selectedCountry={selectedCountry}
                      setSelectedCountry={setSelectedCountry}
                      countryNames={countryNames}
                      specialPostcodes={specialPostcodes}
                      enLocale={enLocale}
                      isReschedule={showAppoinmentData.isUpdate}
                      postcodeValidatorExistsForCountry={
                        postcodeValidatorExistsForCountry
                      }
                      countries={countries}
                      pre_payment_enabled={pre_payment_enabled}
                      postcodeValidator={postcodeValidator}
                      calenderData={calenderData}
                      onFormChange={(c, a) => { }}
                      applyCoupon={applyCoupon}
                      setCouponCode={setCouponCode}
                      couponCode={couponCode}
                      applyingCoupon={applyingCoupon}
                      showCouponInput={showCouponInput}
                      setShowCouponInput={setShowCouponInput}
                      couponApplied={couponApplied}
                      setCouponApplied={setCouponApplied}
                      couponDiscount={couponDiscount}
                      setCouponDiscount={setCouponDiscount}
                      hasFullCouponDiscount={hasFullCouponDiscount}
                      showPaymentColumn={showPaymentColumn}


                    />
                  </Col>
                  {showPaymentColumn && (
                    <Col
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 12 }}
                      lg={{ span: 12 }}
                      xl={{ span: 12 }}
                      xxl={{ span: 12 }}
                    >
                      {/* <PaymentForm form={form} /> */}
                      <div
                        style={{
                          maxWidth: 605,
                          margin: "auto",
                          padding: 10,
                          background: "#fff",
                        }}
                      >
                        <Title
                          level={4}
                          style={{
                            background: "#00838540",
                            fontWeight: "400",
                            padding: 10,
                            borderRadius: "5px",
                            textAlign: "center",
                            color: "#008385",
                          }}
                        >
                          Payment method
                        </Title>
                        <Row
                          gutter={[16, 16]}
                          style={{
                            margin: "auto",
                            width: 393,
                            textAlign: "left",
                          }}
                        >
                          <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 24 }}
                            lg={{ span: 24 }}
                            xl={{ span: 24 }}
                            xxl={{ span: 24 }}
                          >
                            {/* <label style={{ textAlign: 'left', fontSize: 18 }}>Credit & debit card</label> */}
                            <Form.Item
                              name={"paymentMethod"}
                              rules={[
                                {
                                  required: false,
                                  message:
                                    "Payment method selection is required",
                                },
                              ]}
                            >
                              {paymentOption.map((option) => (
                                <div
                                  key={option.type}
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    alignItems: "center",
                                    background: "#F0FAFA",
                                    borderRadius: 25,
                                    padding: "8px 16px",
                                    marginBottom: 8,
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {option.img ? (
                                      <img
                                        src={option.img}
                                        alt={option.type}
                                        style={{
                                          width: 20,
                                          height: 20,
                                          marginRight: 8,
                                        }}
                                      />
                                    ) : (
                                      <CreditCardOutlined
                                        style={{
                                          fontSize: 24,
                                          color: "#000",
                                        }}
                                      />
                                    )}
                                  </div>
                                  <span
                                    style={{
                                      display: "flex",
                                      marginLeft: "20px",
                                    }}
                                  >
                                    <strong>{option.displayName}</strong>
                                  </span>
                                  <Radio
                                    className="round-checkbox "
                                    key={option.type}
                                    checked={true}
                                    onChange={() => handleChange(option.type)}
                                    value={option.type}
                                    style={{
                                      display: "flex",
                                      marginLeft: "auto",
                                    }}
                                  ></Radio>
                                </div>
                              ))}
                            </Form.Item>
                          </Col>
                        </Row>
                        <Title
                          id="stripe-card-section"
                          level={4}
                          style={{
                            background: "#00838540",
                            fontWeight: "400",
                            padding: 10,
                            color: "#008385",
                            borderRadius: "5px",
                            textAlign: "center",
                            marginTop: 20,
                          }}
                        >
                          Payment information:
                        </Title>

                        <Row
                          style={{
                            margin: "auto",
                            width: 393,
                            textAlign: "left",
                          }}
                        >
                          <Col span={24} style={{ padding: 0 }}>
                            <Form.Item
                              label={
                                <div
                                  style={{
                                    color: "#008385",
                                    fontSize: 16,
                                    textAlign: "left",
                                    margin: "auto",
                                    width: 393,
                                    padding: 0,
                                  }}
                                >
                                  Card information
                                </div>
                              }
                              name="cardNumber"
                              rules={[
                                {
                                  required: false,
                                  message: "Card number is required",
                                },
                              ]}
                            >
                              <div className="card-design">
                                <CardNumberElement
                                  options={{
                                    style: {
                                      base: {
                                        fontSize: "16px",
                                        color: "#008385",
                                        "::placeholder": { color: "#008385" },
                                      },
                                      invalid: { color: "red" },
                                    },
                                  }}
                                  className="stripe-input"
                                  onChange={() => setStripeError("")}
                                />
                              </div>
                            </Form.Item>
                          </Col>
                        </Row>

                        {/* CVV and MM/YY on second line */}
                        <Row
                          gutter={8}
                          style={{
                            margin: "auto",
                            width: 393,
                            textAlign: "right",
                          }}
                        >
                          <Col span={12}>
                            <Form.Item
                              label="MM/YY"
                              name="expdata"
                              rules={[
                                {
                                  required: false,
                                  message: "MM/YY is required",
                                },
                              ]}
                            >
                              <div className="card-design">
                                <CardExpiryElement
                                  options={{
                                    style: {
                                      base: {
                                        fontSize: "16px",
                                        color: "#008385",
                                        "::placeholder": { color: "#008385" },
                                      },
                                      invalid: { color: "red" },
                                    },
                                  }}
                                  className="stripe-input"
                                  onChange={() => setStripeError("")}
                                />
                              </div>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item
                              label="CVV"
                              name="cvv"
                              rules={[
                                {
                                  required: false,
                                  message: "cvv is required",
                                },
                              ]}
                            >
                              <div className="card-design">
                                <CardCvcElement
                                  options={{
                                    style: {
                                      base: {
                                        fontSize: "16px",
                                        color: "#008385",
                                        "::placeholder": { color: "#008385" },
                                      },
                                      invalid: { color: "red" },
                                    },
                                  }}
                                  className="stripe-input"
                                  onChange={() => setStripeError("")}
                                />
                              </div>
                            </Form.Item>
                          </Col>
                        </Row>
                        {/* Inline Stripe card error — shown below card fields */}
                        {stripeError && (
                          <div
                            id="stripe-card-error-msg"
                            style={{
                              margin: "6px auto 0",
                              width: 393,
                              color: "#ff4d4f",
                              fontSize: 13,
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                            }}
                          >
                            <span style={{ fontSize: 15 }}>⚠</span>
                            {stripeError}
                          </div>
                        )}
                        <Form.Item
                          label={
                            <div
                              style={{
                                color: "#008385",
                                fontSize: 16,
                                textAlign: "left",
                                margin: "auto",
                                width: 393,
                              }}
                            >
                              Cardholder name
                              <Checkbox
                                onChange={checkisDiffrentCardHolder}
                                checked={isDifferentCardHolder}
                                style={{
                                  textAlign: "left",
                                  width: "100%",
                                  marginBottom: 8,
                                }}
                              >
                                Cardholder is different from the patient
                              </Checkbox>
                            </div>
                          }
                          name="cardHolderName"
                          className={
                            !isDifferentCardHolder ? "cardNameSelect" : ""
                          }
                          style={{
                            margin: "auto",
                            width: 393,
                            marginTop: 15,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                          }}
                          labelAlign="left"
                          rules={[
                            {
                              required: isDifferentCardHolder
                                ? isDifferentCardHolder
                                : false,
                              message: "Cardholder name is required",
                            },
                          ]}
                        >
                          {isDifferentCardHolder && (
                            <Input
                              className="testcase"
                              placeholder="Cardholder name"
                              name="cardHolderName"
                              autoComplete="off"
                              style={{
                                borderRadius: 20,
                                width: "100%",
                                background: "#F0FAFA",
                                color: "#008385",
                              }}
                            />
                          )}
                        </Form.Item>
                        <Form.Item
                          style={{
                            margin: "auto",
                            width: 393,
                            marginTop: 15,
                          }}
                        >
                          <Row gutter={8}>
                            <Col span={24}></Col>
                          </Row>
                        </Form.Item>
                        <Title
                          level={4}
                          style={{
                            background: "#00838540",
                            fontWeight: "400",
                            padding: 10,
                            borderRadius: 5,
                            textAlign: "center",
                            color: "#008385",
                          }}
                        >
                          Payment details
                        </Title>
                        <div
                          style={{
                            display: "grid",
                            margin: "auto",
                            width: 393,
                            marginTop: 15,
                          }}
                        >
                          {/* ── Special Pricing Band badge + Original / Special price rows ── */}
                          {(() => {
                            const _slotInfo = showAppoinmentData?.slot?.info;
                            const _specialBand = _slotInfo?.special_pricing_band;
                            const _normalPrice = _slotInfo?.normal_price;
                            const _slotPrice = _slotInfo?.price;
                            const _isUpdate = showAppoinmentData?.isUpdate && showAppoinmentData?.data?.appointment_id;
                            const _hasRealDiscount = !!_specialBand
                              && Number.isFinite(parseFloat(_slotPrice))
                              && Number.isFinite(parseFloat(_normalPrice))
                              && parseFloat(_slotPrice) < parseFloat(_normalPrice);

                            if (!_isUpdate && _hasRealDiscount) {
                              return (
                                <>
                                  {/* Special Pricing Band badge */}
                                  <div style={{ marginBottom: 8 }}>
                                    <span style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: 5,
                                      background: _specialBand.colour || "#E85D04",
                                      color: "#fff",
                                      borderRadius: 20,
                                      padding: "3px 10px",
                                      fontSize: 12,
                                      fontWeight: 600,
                                    }}>
                                      <TagsOutlined style={{ color: "#fff" }} /> {_specialBand.band_name}
                                    </span>
                                    {_specialBand.description && (
                                      <div style={{ fontSize: 11, color: "#666", marginTop: 3 }}>
                                        {_specialBand.description}
                                      </div>
                                    )}
                                  </div>

                                  {/* Original Price (crossed out) */}
                                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <div style={{ color: "#008385" }}>Original Price</div>
                                    <div style={{ color: "#999", textDecoration: "line-through" }}>
                                      £ {formatPrice(_normalPrice)}
                                    </div>
                                  </div>

                                  {/* Discounted Price */}
                                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <div style={{ color: "#008385", fontWeight: 600 }}>Discounted Price</div>
                                    <div style={{ color: _specialBand.colour || "#E85D04", fontWeight: 600 }}>
                                      £ {formatPrice(_slotPrice)}
                                    </div>
                                  </div>
                                </>
                              );
                            }

                            // Default — no special pricing band
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div style={{ color: "#008385" }}>{showAppoinmentData?.isUpdate ? "Rescheduling charge" : "Amount"}</div>
                                <div style={{ color: "#008385" }}>
                                  £{" "}
                                  {showAppoinmentData &&
                                    showAppoinmentData?.isUpdate &&
                                    showAppoinmentData?.data?.appointment_id
                                    ? showAppoinmentData.clinic.isChargesOverRide ? "0.00" : showAppoinmentData?.data
                                      ?.rescheduling_charge
                                    : showAppoinmentData &&
                                      showAppoinmentData?.slot?.info.price
                                      ? formatPrice(showAppoinmentData?.slot?.info.price)
                                      : "0.00"}
                                </div>
                              </div>
                            );
                          })()}
                          {couponDiscount > 0 && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <div
                                style={{ color: "#008385", fontWeight: "400" }}
                              >
                                Discount
                              </div>
                              <div style={{ color: "#008385" }}>-£ {Number(couponDiscount).toFixed(2)}</div>
                            </div>
                          )}
                          {(() => {
                            const _slotInfo = showAppoinmentData?.slot?.info;
                            const _specialBand = _slotInfo?.special_pricing_band;
                            const _normalPrice = _slotInfo?.normal_price;
                            const _slotPrice = _slotInfo?.price;
                            const _isUpdate = showAppoinmentData?.isUpdate && showAppoinmentData?.data?.appointment_id;
                            const _hasRealDiscount = !!_specialBand
                              && Number.isFinite(parseFloat(_slotPrice))
                              && Number.isFinite(parseFloat(_normalPrice))
                              && parseFloat(_slotPrice) < parseFloat(_normalPrice);
                            if (_isUpdate || !_hasRealDiscount) return null;

                            // Total saving = special-band discount + coupon discount (if any),
                            // so "You Save" always equals Original Price − Total.
                            const _bandSaving = parseFloat(_normalPrice) - parseFloat(_slotPrice);
                            const _couponSaving = couponDiscount > 0 ? parseFloat(couponDiscount) : 0;
                            const _totalSaving = (_bandSaving + _couponSaving).toFixed(2);

                            return (
                              <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div style={{ color: "#008385", fontWeight: 500 }}>You Save</div>
                                <div style={{ color: "#008385", fontWeight: 500 }}>
                                  - £ {_totalSaving}
                                </div>
                              </div>
                            );
                          })()}
                          {showAppoinmentData?.isUpdate ?
                            <>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div
                                  style={{ color: "#008385", fontWeight: "400" }}
                                >
                                  Additional charge
                                </div>
                                <div style={{ color: "#008385" }}>£{" "}{formatPrice(parseFloat(showAppoinmentData?.slot?.info?.additional_charges))}</div>
                              </div>
                            </>
                            : ''}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{ color: "#008385", fontWeight: "400" }}
                            >
                              Payment Method
                            </div>
                            <div style={{ color: "#008385" }}>Card</div>
                          </div>
                          <hr
                            style={{
                              borderTop: "2px solid #ccc",
                              margin: "10px 0",
                            }}
                          />
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div style={{ color: "#008385" }}>Total</div>
                            <div style={{ color: "#008385" }}>
                              £{" "}
                              {(() => {
                                if (
                                  showAppoinmentData &&
                                  showAppoinmentData?.isUpdate &&
                                  showAppoinmentData?.data?.appointment_id
                                ) {
                                  if (
                                    showAppoinmentData.clinic.isChargesOverRide ||
                                    showAppoinmentData.clinic.isAdditionalChargesOverridden
                                  ) {
                                    return formatPrice(
                                      parseFloat(showAppoinmentData?.slot?.info?.additional_charges) || 0,
                                    );
                                  }

                                  // Total must match the sum of the line items shown above it
                                  // (Rescheduling charge + Additional charge), not the original/new
                                  // slot price — those are two different amounts.
                                  const reschedulingCharge =
                                    parseFloat(showAppoinmentData?.data?.rescheduling_charge) || 0;
                                  const additional =
                                    parseFloat(showAppoinmentData?.slot?.info?.additional_charges) || 0;

                                  return formatPrice(reschedulingCharge + additional);
                                }

                                if (showAppoinmentData && showAppoinmentData?.slot?.info.price) {
                                  const amount = parseFloat(showAppoinmentData?.slot?.info.price) || 0;
                                  const discount =
                                    couponDiscount && couponDiscount > 0
                                      ? parseFloat(couponDiscount) || 0
                                      : 0;

                                  return formatPrice(amount - discount);
                                }

                                return "0.00";
                              })()}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  )}
                </Row>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                  lg={{ span: 24 }}
                  xl={{ span: 24 }}
                  xxl={{ span: 24 }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginLeft: 0,
                      alignItems: "center",
                    }}
                  >
                    <Button
                      shape="circle"
                      icon={
                        <ArrowLeftOutlined
                          style={{ color: "#008385", fontSize: "18px" }}
                        />
                      }
                      style={{
                        backgroundColor: "#C8E6E6", // Light teal
                        border: "none",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        // marginTop: 20,
                        marginRight: 10,
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                      }}
                      onClick={() => {
                        // The old confirm-your-booking screen is gone — go back
                        // directly to slot selection (whichever screen got us here).
                        callBackForbackpage(showAppoinmentData?.type || "BookingForm");
                        pushTraceLogEvent({
                          event: "navigate_to_appointment_sumary",
                          payload: {
                            action: "navigate to appointment sumary",
                          },
                          step_status: "success",
                        });
                      }}
                    />
                    {/* Countdown Timer Display */}
                    {countdownStartTime && timeRemaining > 0 && (
                      <div
                        style={
                          {
                            // position: 'relative',
                            // // top: '20px',
                            // // right: '20px',
                            // zIndex: 1000
                          }
                        }
                      >
                        <CountdownDisplay />
                      </div>
                    )}
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="bookin-icon"
                      loading={formloading}
                      // onClick={() => callbackAppointment({ confirm: 'confirm' }, 'BookingConfirmation')} Pay and
                      style={{
                        width: 150,
                        height: 40,
                        background: "#008385",
                        borderColor: "#008385",
                        marginTop: 20,
                        marginBottom: 20,
                      }}
                    >
                      Book now
                    </Button>
                  </div>
                </Col>
              </Form>
            </div>
          )}
        {showAppoinmentData &&
          clinicSelected &&
          showAppoinmentDataDisplay == "BookingConfirmation" && (
            <BookingConfirmation
              getAllHealthScreenData={{ getAllHealthScreenData, allGPproduct }}
              showAppoinmentData={showAppoinmentData}
              data={location.state}
              hideConfirm={hideConfirm}
              discount={showAppoinmentData?.confirm?.appliedDiscount || 0}
              isUpdate={showAppoinmentData?.isUpdate}
            />
          )}
      </div>
      {modalStatus && calenderData && Object.keys(calenderData).length && (
        <ClinicCalenderModal
          getAllHealthScreenData={{ getAllHealthScreenData, allGPproduct }}
          modalStatus={modalStatus}
          data={location.state}
          calenderData={calenderData}
          onClose={onClose}
          onSubmit={onSubmit}
        />
      )}
      {appointmentType && (
        <CalendarEventModal
          getAllHealthScreenData={{ getAllHealthScreenData, allGPproduct }}
          status={appointmentType}
          lantumStartAndEndDate={lantumStartAndEndDate}
          type={showAppoinmentDataDisplay}
          callback={callbackLunchAndSpacer}
          callbackWithData={createSpaceAndLunch}
          data={clinicSelected}
          ifError={errorMessage}
          spacerAndLunch={spacerAndLunch}
        />
      )}

      {/* IOO-275: Session Extension Warning Modal — extracted to reusable component */}
      <SessionWarningModal
        isOpen={showExtensionWarningModal && timeRemaining >= 1000}
        timeRemaining={timeRemaining}
        onExtend={handleExtendSession}
        onDecline={handleDeclineExtension}
        maxExtensionsReached={maxExtensionsReached}
        extensionsUsed={extensionCount}
        maxExtensions={sessionConfig.max_extensions}
      />

      {/* Time Expired Modal */}
      <Modal
        title="Session Expired"
        open={showTimeExpiredModal}
        onOk={handleTimeExpiredOk}
        onCancel={handleTimeExpiredOk}
        closable={false}
        centered
        footer={[
          <Button key="ok" type="primary" onClick={handleTimeExpiredOk}>
            OK
          </Button>,
        ]}
      >
        <div style={{ textAlign: "center", padding: "20px 0" }}>
          <ClockCircleOutlined
            style={{ fontSize: "48px", color: "#ff4d4f", marginBottom: "16px" }}
          />
          <p style={{ fontSize: "16px", marginBottom: "8px" }}>
            Your booking session has expired.
          </p>
          <p style={{ color: "#666" }}>
            Please start the booking process again.
          </p>
        </div>
      </Modal>



      {/* </Elements>
             ) : (
                <Spin className="custom-spinner" />
            )} */}
    </App>
  );
}

export default ClinicCalendarPage;
